//! Grant Access (with GroupShare) - under development
import React, { Component } from "react";
import Select, { AriaOnFocus } from "react-select";
import ReactTooltip from "react-tooltip";

import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  Button,
  FormGroup,
  // ControlLabel,
  FormControl,
  Row,
  Radio,
} from "react-bootstrap";
import { Modal, Checkbox } from "react-bootstrap";
import ShareLock from "../Tutorial/ShareLockGuide";
import DatePicker from "react-datepicker";
// import TimeInput from 'react-time-input';
import "react-datepicker/dist/react-datepicker.css";
// import axios from "axios";
import _ from "lodash";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import withAuthorization from "../../components/Authorization/withAuthorization";
// import { doGetLocklist, doGetUserlist, fire, auth } from "../../firebase/index";
import { fire, auth } from "../../firebase/index";
import "../../routes/app";
import Switch from "react-switch";
import NotificationSystem from "react-notification-system";
import { grantUserAccess } from "./GrantAccessHelper";
import { grantUserLockGroupAccess } from "./GrantAccessHelper";
import {
  style,
  customLog,
  monthNamesShort,
  planToNumber,
  egeeTouchPlans,
} from "../../variables/Variables";
//For Approval Status
// import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// import BootstrapTable from 'react-bootstrap-table-next';
// import paginationFactory from 'react-bootstrap-table2-paginator';
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";
//css
import "../../assets/css/mapview.css";
import "../../assets/css/maincss.css";

import Multiselect from "react-widgets/lib/Multiselect";
import "react-widgets/dist/css/react-widgets.css";
import "../../assets/css/header.css";

import RecipientsTable from "./RecipientsTable";
import GroupsTable from "./GroupsTable";
import AdminsTable from "./AdminsTable";
import ShareHistory from "../ShareHistory/index";
import LockScheduling from "../LockScheduling/LockScheduling";
import GroupSharing from "../GroupSharing/index";
import FilterOption from "./FilterOption";

// import { set } from "immutable";

import LocalizedStrings from "react-localization";
import { compose } from "redux";
import { isSuper } from "@babel/types";
import { each } from "bluebird";
let localizationStrings = new LocalizedStrings({
  en: {
    startTimeTitle: "Select your start time",
    endTimeTitle: "Select your end time",
    grantAccessTitle: "Grant Access",
    descriptionSubtitle: "Grant an lock access to recipient",
    lockSharingTab: "Lock Sharing",
    step1Message: "Step 1 : Select A Lock",
    selectLockTitle: "Please Select A Lock",
    selectLockGroup: "Please Select A Lock Group",
    selectLockTitleindividual: "Individual Lock",
    selectLockTitleGroup: "Lock Group",
    step2Message: "Step 2 : Select A Type",
    selectTypeTitle1: "Individual",
    selectTypeTitle2: "Group",
    step3IndividualMessage: "Step 3 : Select A Recipient",
    step3GroupMessage: "Step 3 : Select A Group",
    selectRecipientTitle: "Please Select a Recipient",
    step4Message: "Step 4 : Select Sharing Type",
    step4RecurringOption: "Recurring",
    step4NormalOption: "Regular",
    step4RecurringTitle: "Select day(s) :",
    step4AccessTitle: "Access period",
    step4Start: "Start: ",
    step4End: "End: ",
    step4SelectDaily: "Select daily access:",
    step4FullDay: "Full-day Access",
    step4Timed: "Timed Access",
    step4FromOption: "From",
    step4ToOption: " to ",
    checkboxText: "Allow admin to share lock to others",
    // checkboxText: "Do not allow admin to share lock to others",
    step5SubMessage: "* For Multi Approve *",
    step5Message: "Step 4 : Select an Approval Admin",
    usernameTip:
      "The start & end time of a given share access. User will not be able to lock or unlock when access period expires.",
    usernameTip2:
      "Set approving members to approve the shared access before users is allowed to lock & unlock the padlock",
    usernameTip3:
      "When turned on. User is allowed to unlock & lock the padlock once within the access period",
    // step4Message: "Step 4 : Select an Admin for Multi Approve",
    timedAccessTitle: "Timed Access",
    unrestrictedTitle: "User will have unrestricted time access",
    sharingModeTitle: "Sharing Mode",
    sharingMode2Title: "Disable Shared Locks",
    onlineWarning: "Online: User has to be online to access lock",
    offlineWarning:
      "Offline: Locks are accessible offline, but retracting locks will only take effect once the recipient is online.",
    online2Warning: "Only Non-Shared Locks Will Be Selectable",
    offline2Warning: "All Locks Are Selectable",
    emailHeader: "Email address",
    nameHeader: "Name",
    sendButton: "Send Remote Access",
    clearButton: "Clear All",
    alertmessage: "Your Recipient Has No EgeeTouch App, Please Install!",
    shareHistoryTab: "Share History",
    lockSchedulingTab: "Lock Scheduling",
    availableOnlineOnly: "Only Available For Online",
    mutliApprove: "Multi Approve",
    oneTimeAccess: "One Time Access",
    requestAccessFrom: "Request access from..",
    shareLockGuide: "Share Lock",
    exceededPlanLimits:
      "Please delete some members as you have exceeded plan limits",
    exceededLockLimits:
      "Please delete some locks as you have exceeded plan limits",
    invalidTime: "Please input a valid time for start time and end time",
    multiAccess: "Multiple Access of",
    singleAccess: "Access of",
    given: "given !",
    userWOApp1: "Please ensure",
    userWOApp2: "has eGeeTouch App !",
    selectAdmin: "Please select an admin for permission approval",
    emptyField: "Please select a Lock and Recipient",
    emptyFieldGroup: "Please select a Lock and Group",
    myLocksLabel: "My Locks",
    allLockGroupsLabel: "All Lock Groups",
    sharedLocksLabel: "Shared Locks",
    invalidLock:
      "You can only allow recipients to share locks that are owned by you, please select another lock",
    invalidRecurring: "You must select at least 1 day for recurring access",
    invalidRecurringSelectedTime: "Please select a start and end time",
    invalidRecurringStartTime: "Start time can not be later than the end time",
    timedAccessLock1: "You are only allowed to share the lock between",
    timedAccessLock2: "and",
    timedAccessLock3: "",
    everyLabel: "Every ",
    recurringDaySun: "Sun",
    recurringDayMon: "Mon",
    recurringDayTue: "Tue",
    recurringDayWed: "Wed",
    recurringDayThu: "Thu",
    recurringDayFri: "Fri",
    recurringDaySat: "Sat",
    recurringCurrentlyUnavailable:
      "*Currently not available for Multi approval and One Time Access",
    waitMessage: "Processing request, please wait...",
    processing: "Processing...",
    noLocks: "No locks available",
    noLockGroups: "No lock groups available",
    noShareableLocks: "You have no shareable locks available",
    noShareableLockGroups: "You have no shareable lock groups available",
  },
  ja: {
    startTimeTitle: "アクセス開始時間",
    endTimeTitle: "アクセス終了時間",
    grantAccessTitle: "アクセス設定",
    descriptionSubtitle: "受信者にロックアクセスを許可する",
    lockSharingTab: "ロック共有",
    step1Message: "Step 1　ロックを選択",
    selectLockTitle: "ハードウェア選択",
    selectLockTitleindividual: "個別ロック",
    selectLockGroup: "ロックグループを選択してください",
    selectLockTitleGroup: "ロックグループ",
    step2Message: "Step 2　種類を選択",
    selectTypeTitle1: "個別登録",
    selectTypeTitle2: "グループ",
    step3IndividualMessage: "Step 3　メンバーを選択",
    step3GroupMessage: "Step 3　グループを選択",
    selectRecipientTitle: "メンバー選択",
    step4Message: "Step 4　アクセススケジュールの選択",
    step4RecurringOption: "曜日選択",
    step4NormalOption: "無制限",
    step4RecurringTitle:
      "曜日選択（選択した曜日全て同じ時間帯の設定になります）",
    step4AccessTitle: "アクセス期間",
    step4Start: "開始日時: ",
    step4End: "終了日時: ",
    step4SelectDaily: "設定時間",
    step4FullDay: "24時間設定",
    step4Timed: "時間制限",
    step4FromOption: "から",
    step4ToOption: " まで ",
    checkboxText: "メンバーへロックのアクセス許可を承認する",
    // checkboxText: "管理者が他の人とロックを共有できないようにする",
    step5SubMessage: "* マルチ承認 *",
    step5Message: "Step4　副管理者を選択",
    // step4Message: "Step 4 マルチ承認のための管理者を選択",
    timedAccessTitle: "タイムアクセス",
    unrestrictedTitle: "アクセス制限無し",
    sharingModeTitle: "アクセスモード",
    onlineWarning: "オンライン（推奨）；オンラインでのアクセスを許可",
    offlineWarning:
      "オフライン: ロックはオフラインでもアクセスできますが、ロックの撤回は受信者がオンラインになって初めて有効になります。",
    emailHeader: "Eメール",
    nameHeader: "名前",
    sendButton: "アクセス権限を与える",
    clearButton: "クリア",
    alertmessage:
      "エラーメッセージ 選択したサブユーザーは、アプリケーションのアカウントが未登録です。登録して下さい。",
    shareHistoryTab: "アクセス履歴",
    lockSchedulingTab: "ロックスケジューリング",
    availableOnlineOnly: "オンラインのみ有効",
    mutliApprove: "複数承認",
    oneTimeAccess: "ワンタイムアクセス",
    requestAccessFrom: "からのアクセスを要求する",
    shareLockGuide: "ロックを共有する",
    exceededPlanLimits:
      "ご使用プランの制限内でメンバーアカウント数を追加してください。",
    exceededLockLimits:
      "プランの制限を超えたため、いくつかのロックを削除してください",
    invalidTime: "タイムアクセス開始時間と終了時間を入れて下さい。",
    multiAccess: "マルチ承認",
    singleAccess: "アクセス",
    given: "処理完了",
    userWOApp1: "確認",
    userWOApp2: "すでにアプリ登録済です。",
    selectAdmin: "承認アカウントを選択して下さい。",
    emptyField: "スマートロックとメンバーを選択",
    emptyFieldGroup: "スマートロックとグループを選択",
    myLocksLabel: "登録ロック一覧",
    allLockGroupsLabel: "すべてのロックグループ",
    sharedLocksLabel: "ロックをシェアする",
    invalidLock:
      "このアカウントで登録済のロックのみ選択することができます。登録済のロックを選択して下さい。",
    invalidRecurring:
      "定期的なアクセスには少なくとも1日を選択する必要があります。",
    invalidRecurringSelectedTime: "開始時間と終了時間を選択します。",
    invalidRecurringStartTime: "開始時間は終了時間の前を選択します。",
    timedAccessLock1: "シェアできるロックは",
    timedAccessLock2: "と",
    timedAccessLock3: "です。",
    everyLabel: "毎週 ",
    recurringDaySun: "日",
    recurringDayMon: "月",
    recurringDayTue: "火",
    recurringDayWed: "水",
    recurringDayThu: "木",
    recurringDayFri: "金",
    recurringDaySat: "土",
    recurringCurrentlyUnavailable:
      "※「曜日選択」でのマルチ承認、ワンタイムパスワードは現在使用できません。",
    waitMessage: "リクエストを処理しています、お待ちください...",
    processing: "処理...",
    noLocks: "利用可能なロックがありません",
    noLockGroups: "使用可能なロック グループがありません",
    noShareableLocks: "利用可能な共有可能なロックがありません",
    noShareableLockGroups: "使用可能な共有可能なロック グループがありません",
  },
  es: {
    startTimeTitle: "Selecciona tu hora de inicio",
    endTimeTitle: "Selecciona tu hora de finalización",
    grantAccessTitle: "Conceder Acceso",
    descriptionSubtitle: "Conceder acceso a la candado al destinatario",
    lockSharingTab: "Compartición de Candados",
    step1Message: "Paso 1 : Selecciona una Candado",
    selectLockTitle: "Por favor selecciona una candado",
    selectLockGroup: "Por favor selecciona un grupo de candados",
    selectLockTitleindividual: "Candado Individual",
    selectLockTitleGroup: "Grupo de Candados",
    step2Message: "Paso 2 : Selecciona un Tipo",
    selectTypeTitle1: "Individual",
    selectTypeTitle2: "Grupo",
    step3IndividualMessage: "Paso 3 : Selecciona un Destinatario",
    step3GroupMessage: "Paso 3 : Selecciona un Grupo",
    selectRecipientTitle: "Por favor selecciona un destinatario",
    step4Message: "Paso 4 : Selecciona el Tipo de Compartición",
    step4RecurringOption: "Recurrente",
    step4NormalOption: "Regular",
    step4RecurringTitle: "Selecciona día(s) :",
    step4AccessTitle: "Período de acceso",
    step4Start: "Inicio: ",
    step4End: "Fin: ",
    step4SelectDaily: "Selecciona acceso diario:",
    step4FullDay: "Acceso Todo el Día",
    step4Timed: "Acceso Temporal",
    step4FromOption: "Desde",
    step4ToOption: " hasta ",
    checkboxText: "Permitir al administrador compartir la candado con otros",
    // checkboxText: "No permitir al administrador compartir la candado con otros",
    step5SubMessage: "* Para Aprobación Múltiple *",
    step5Message: "Paso 4 : Selecciona un Administrador de Aprobación",
    usernameTip:
      "La hora de inicio y fin de un acceso compartido dado. El usuario no podrá bloquear o desbloquear cuando expire el período de acceso.",
    usernameTip2:
      "Establecer miembros aprobadores para aprobar el acceso compartido antes de que se permita a los usuarios bloquear y desbloquear la candado.",
    usernameTip3:
      "Cuando está activado. El usuario puede desbloquear y bloquear la candado una vez dentro del período de acceso.",
    // step4Message: "Paso 4 : Selecciona un Administrador para Aprobación Múltiple",
    timedAccessTitle: "Acceso Temporal",
    unrestrictedTitle: "El usuario tendrá acceso temporal sin restricciones",
    sharingModeTitle: "Modo de Compartición",
    sharingMode2Title: "Deshabilitar Candados Compartidas",
    onlineWarning:
      "En línea: El usuario debe estar en línea para acceder a la candado",
    offlineWarning:
      "Fuera de línea: Se puede acceder a los bloqueos sin conexión, pero la retracción de los bloqueos solo tendrá efecto una vez que el destinatario esté en línea.",
    online2Warning: "Solo se podrán seleccionar candados no compartidas",
    offline2Warning: "Todas las candados son seleccionables",
    emailHeader: "Dirección de correo electrónico",
    nameHeader: "Nombre",
    sendButton: "Enviar Acceso Remoto",
    clearButton: "Limpiar Todo",
    alertmessage:
      "¡Tu destinatario no tiene la aplicación EgeeTouch, por favor instálala!",
    shareHistoryTab: "Historial de Compartición",
    lockSchedulingTab: "Programación de Candados",
    availableOnlineOnly: "Solo disponible para en línea",
    mutliApprove: "Aprobación Múltiple",
    oneTimeAccess: "Acceso Único",
    requestAccessFrom: "Solicitar acceso de..",
    shareLockGuide: "Compartir Candado",
    exceededPlanLimits:
      "Por favor elimina algunos miembros ya que has superado los límites del plan",
    exceededLockLimits:
      "Por favor elimina algunas candados ya que has superado los límites del plan",
    invalidTime:
      "Por favor ingresa un tiempo válido para la hora de inicio y la hora de finalización",
    multiAccess: "Acceso Múltiple de",
    singleAccess: "Acceso de",
    given: "¡dado!",
    userWOApp1: "Por favor asegúrate de que",
    userWOApp2: "tiene la aplicación eGeeTouch!",
    selectAdmin:
      "Por favor selecciona un administrador para la aprobación de permisos",
    emptyField: "Por favor selecciona una candado y un destinatario",
    emptyFieldGroup: "Por favor selecciona una candado y un grupo",
    myLocksLabel: "Mis Candados",
    allLockGroupsLabel: "Todos los Grupos de Candados",
    sharedLocksLabel: "Candados Compartidas",
    invalidLock:
      "Solo puedes permitir que los destinatarios compartan candados que sean de tu propiedad, por favor selecciona otra candado",
    invalidRecurring:
      "Debes seleccionar al menos 1 día para el acceso recurrente",
    invalidRecurringSelectedTime:
      "Por favor selecciona una hora de inicio y una hora de finalización",
    invalidRecurringStartTime:
      "La hora de inicio no puede ser posterior a la hora de finalización",
    timedAccessLock1: "Solo se te permite compartir la candado entre",
    timedAccessLock2: "y",
    timedAccessLock3: "",
    everyLabel: "Cada ",
    recurringDaySun: "Dom",
    recurringDayMon: "Lun",
    recurringDayTue: "Mar",
    recurringDayWed: "Mié",
    recurringDayThu: "Jue",
    recurringDayFri: "Vie",
    recurringDaySat: "Sáb",
    recurringCurrentlyUnavailable:
      "*Actualmente no disponible para aprobación múltiple y acceso único",
    waitMessage: "Procesando solicitud, por favor espere...",
    processing: "Procesando...",
    noLocks: "No hay candados disponibles",
    noLockGroups: "No hay grupos de candados disponibles",
    noShareableLocks: "No tienes candados compartibles disponibles",
    noShareableLockGroups:
      "No tienes grupos de candados compartibles disponibles",
  },
});

class GrantAccess extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeOTA = this.handleChangeOTA.bind(this);
    // Force Update
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    this.handlewindowShow = this.handlewindowShow.bind(this);
    this.eraseAll = this.eraseAll.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.onSendRemoteAccess = this.onSendRemoteAccess.bind(this);
    this.showSharedNotification = this.showSharedNotification.bind(this);

    this.state = {
      locklistArray: [],
      userFriendListArray: [],
      loading: true,
      invalidMemberLimit: true,
      invalidLockLimit: true,
      userArray: [],

      actualDateTime: 0,
      startDate: new Date(new Date().setMinutes(0, 0, 0)),
      endDate: new Date(new Date().setMinutes(0, 0, 0)),

      timechecked: false,
      isRetractMode: true,
      OTAMode: false,
      disabledState: false, //for OTA & Sharing Mode
      disabledStateMultiShare: false, //for Multishare & Sharing Mode

      //sharing variable
      selectedLock: null,

      calendarStartText: localizationStrings.startTimeTitle,
      calendarEndText: localizationStrings.endTimeTitle,

      recurringStartText: localizationStrings.startTimeTitle,
      recurringEndText: localizationStrings.endTimeTitle,

      startTime: null,
      endTime: null,

      selectedFriendsArray: [],
      isMultipleSendingMode: false,

      _notificationSystem: null,

      selectedRecipients: [],
      showTable: false,

      selectedAdmins: [],
      adminDetails: [],
      showAdminLists: false,
      subtractAdminArray: [],
      subtractRecipientArray: [],

      AlllockGroupArray: [],

      showPopup: false,
      popupTitle: "",
      popupImage: [],

      limitApproval: 0,
      emptyArray: [],

      radioIndividualLockChecked: true, //added
      radioGrouplockChecked: false, // added
      radioIndividualChecked: true,
      radioGroupChecked: false,
      radioNormalChecked: true,
      radioRecurringChecked: false,

      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      recurringFullDay: true,
      recurringTimed: false,

      groupListArray: [],
      selectedGroups: [],
      selectedLockgroup: null,
      superAdminID: "",
      isSuperAdmin: false,
      checkboxChecked: false,
      checkboxChecked5: false,
      checkboxChecked6: false,

      isSharedLock: false,
      disabledStateShareLock: false, //for OnlineSharedLock & Sharing Mode
      currentLanguage: "",
      historyArray: [],
      isDisabledSwitch: true,

      initialLoading: true,
      processing: false,

      noShareableLocks: false,
      noShareableLockGroups: false,
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.detectOnLockDropdownChangeEvent = this.detectOnLockDropdownChangeEvent.bind(
      this
    );
    this.detectOnLockDropdownChangeEvent2 = this.detectOnLockDropdownChangeEvent2.bind(
      this
    );

    this.handleRadioFullDay = this.handleRadioFullDay.bind(this);
    this.handleRadioTimeAccess = this.handleRadioTimeAccess.bind(this);
    this.handleTimedAccess = this.handleTimedAccess.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.handleFriendsArray = this.handleFriendsArray.bind(this);
    this.handleGroupsArray = this.handleGroupsArray.bind(this);
    this.handleChangeMultiSharing = this.handleChangeMultiSharing.bind(this);
    this.conditionRenderingMultiData = this.conditionRenderingMultiData.bind(
      this
    );
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleRadioIndividual = this.handleRadioIndividual.bind(this);
    this.handleRadioGroup = this.handleRadioGroup.bind(this);
    this.handleRadioNormal = this.handleRadioNormal.bind(this);
    this.handleRadioRecurring = this.handleRadioRecurring.bind(this);
    this.radioIndividualLock = this.radioIndividualLock.bind(this);
    this.radioGrouplock = this.radioGrouplock.bind(this);
    this.handleTabs = this.handleTabs.bind(this);
    this.handleCheck = this.handleCheck.bind(this);

    this.handleRecurringCheck = this.handleRecurringCheck.bind(this);
    this.convertStartTime = this.convertStartTime.bind(this);
    this.convertEndTime = this.convertEndTime.bind(this);
  }

  snapshotToArray(snapshot) {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  }

  async handleStartDateChange(startDate) {
    var dateFormatted = startDate.getTime() / 1000;
    var actualDateTime = Math.floor(Date.now() / 1000 - 86400); // Buffer 24 hours from current time

    customLog(dateFormatted);

    var hour, minute;

    if (startDate.getHours() < 10) {
      hour = "0" + startDate.getHours();
    } else {
      hour = startDate.getHours();
    }

    if (startDate.getMinutes() === 0) {
      minute = startDate.getMinutes() + "0";
    } else {
      minute = startDate.getMinutes();
    }

    var dateString = `${
      monthNamesShort[startDate.getMonth()]
    } ${startDate.getDate()} ${startDate.getFullYear()}, ${hour} : ${minute}`;

    customLog(dateString);

    await this.setState({
      startDate: startDate,
      calendarStartText: startDate.toString(),
      selectedStartShareTime: parseInt(dateFormatted, 0),
      selectedStartTimeString: dateString,
      actualDateTime: actualDateTime.toString(),
    });

    // customLog(this.state.selectedStartShareTime)
  }

  async handleEndDateChange(endDate) {
    // customLog("handleEndDateChange " + endDate)
    var dateFormatted = endDate.getTime() / 1000;
    var actualDateTime = Math.floor(Date.now() / 1000 - 86400); // Buffer 24 hours

    var hour, minute;

    if (endDate.getHours() < 10) {
      hour = "0" + endDate.getHours();
    } else {
      hour = endDate.getHours();
    }

    if (endDate.getMinutes() === 0) {
      minute = endDate.getMinutes() + "0";
    } else {
      minute = endDate.getMinutes();
    }

    var dateString = `${
      monthNamesShort[endDate.getMonth()]
    } ${endDate.getDate()} ${endDate.getFullYear()}, ${hour} : ${minute}`;

    await this.setState({
      endDate: endDate,
      calendarEndText: endDate.toString(),
      selectedEndShareTime: parseInt(dateFormatted, 0),
      selectedEndTimeString: dateString,
      actualDateTime: actualDateTime.toString(),
    });
    // customLog(this.state.selectedEndShareTime)
  }

  handleStartTimeChange(startTime) {
    var timeFormatted = startTime.getTime() / 1000;

    customLog(startTime);
    this.setState({
      recurringStartText: startTime.toString(),
      startTime: startTime,
    });
  }

  handleEndTimeChange(endTime) {
    var timeFormatted = endTime.getTime() / 1000;

    this.setState({
      recurringEndText: endTime.toString(),
      endTime: endTime,
    });
  }

  handleTimedAccess(timechecked) {
    this.setState({ timechecked });

    if (!timechecked) {
      this.setState({ selectedEndShareTime: 0, selectedStartShareTime: 0 });
    }
  }

  handleChange(isRetractMode) {
    this.setState({ isRetractMode });
  }

  handleChangeOTA(OTAMode) {
    this.setState((prevState) => ({
      OTAMode: !prevState.OTAMode,
      disabledState: !prevState.OTAMode,
    }));
    if (OTAMode) {
      this.setState({
        isRetractMode: true,
      });
    }
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    const historyRef = fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey();

    // Set up the listener for changes in the MyShareHistory node
    historyRef.on("value", (snapshot) => {
      const tempArray = [];
      snapshot.forEach((childSnapshot) => {
        const item = childSnapshot.val();
        item.key = childSnapshot.key;
        tempArray.push(item);
      });
      this.setState({
        historyArray: tempArray.reverse(),
        loading: false,
      });
    });

    setTimeout(() => {
      this.setState({ initialLoading: false });
    }, [2000]); // 1.5sec loading for lock selection dropdowns to finish populating and rendering
  }

  componentDidUpdate(prevProps, prevState) {
    const dropdownData1 = this.renderDropdown();
    const dropdownData2 = this.renderDropdown2();

    const isEmpty1 = dropdownData1.every(
      (group) => !group.options || group.options.length === 0
    );

    if (isEmpty1 !== this.state.noShareableLocks) {
      this.setState({ noShareableLocks: isEmpty1 });
    }

    const isEmpty2 = dropdownData2.every(
      (group) => !group.options || group.options.length === 0
    );

    if (isEmpty2 !== this.state.noShareableLockGroups) {
      this.setState({ noShareableLockGroups: isEmpty2 });
    }
  }

  componentWillMount() {
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        const snapshotVal = snapshot.val();
        // customLog(snapshotVal);
        let lockArrayWithShareRights = [];
        let lockDetails = {};
        let snapId = {};
        for (const eachLockId in snapshotVal) {
          if (
            snapshotVal[eachLockId].sharedBy === "" ||
            snapshotVal[eachLockId].sharePermissionType === 1
          ) {
            const currTimeStamp = Math.floor(Date.now() / 1000);

            //! Condition to check if Time Access Shared Lock is within the time period
            //? Check if it's shared lock with time access, if yes check whether current datetime is within access time period
            if (
              snapshotVal[eachLockId].sharedBy !== "" &&
              snapshotVal[eachLockId].shareStartTime > 0 &&
              snapshotVal[eachLockId].shareEndTime > 0 &&
              (snapshotVal[eachLockId].shareStartTime > currTimeStamp ||
                snapshotVal[eachLockId].shareEndTime < currTimeStamp)
            ) {
              //? Not Within Time Period, unable to access lock
            } else {
              snapId = { snapId: eachLockId };
              lockDetails = {
                ...snapshotVal[eachLockId],
                ...snapId,
              };
              lockArrayWithShareRights.push(lockDetails);
            }
          }
        }

        this.setState({
          locklistArray: lockArrayWithShareRights,
          loading: false,
        });
        // }
      })
      .catch((err) => {
        customLog(err);
      });

    // Replacing Axios
    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let friendListArray = [];
        let friendDetails = {};
        snapshot.forEach((user) => {
          // customLog(user.val());
          const userDetails = user.val();
          const userName = userDetails.friendName;
          const userEmail = userDetails.friendEmail;
          // friendListArray[userName] = userEmail;
          friendDetails = {
            userName: userName,
            userEmail: userEmail,
          };

          friendListArray.push(friendDetails);

          this.setState({
            userFriendListArray: friendListArray,
            loading: false,
          });
        });
        // customLog(friendListArray);
        // this.setState({userFriendListArray : friendListArray});
      })
      .catch((err) => customLog(err));

    //check if members is within the maxUsers limit
    //if it's more than the limit, user will not be able to share any lock
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            // console.log(eachSuperAdmin.val());
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;
            for (const eachMembers in members) {
              if (members[eachMembers].memberEmail === auth.currentUser.email) {
                const superAdminId = eachSuperAdmin.key;
                const maxUserLimit = eachSuperAdminDetails.payment.maxUsers;
                const maxUserLocks = eachSuperAdminDetails.payment.maxLocks;
                customLog(superAdminId);

                fire
                  .database()
                  .ref("userLocks/" + superAdminId)
                  .once("value")
                  .then((snapshot) => {
                    const childInDb = snapshot.numChildren();
                    if (childInDb > maxUserLocks) {
                      this.setState({
                        invalidLockLimit: true,
                      });
                      this.showNotification(
                        localizationStrings.exceededLockLimits,
                        "error",
                        0,
                        ""
                      );
                    } else {
                      this.setState({
                        invalidLockLimit: false,
                      });
                    }
                  });

                fire
                  .database()
                  .ref("groupAccounts/" + superAdminId + "/members")
                  .once("value")
                  .then((snapshot) => {
                    const childInDb = snapshot.numChildren();
                    if (childInDb > maxUserLimit) {
                      this.setState({
                        invalidMemberLimit: true,
                      });
                      this.showNotification(
                        localizationStrings.exceededPlanLimits,
                        "error",
                        0,
                        ""
                      );
                    } else {
                      this.setState({
                        invalidMemberLimit: false,
                      });
                    }
                  });
              }
            }
          });
        }
      });

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            // console.log(eachSuperAdmin.val());
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;
            let maxMulti;

            let adminDetailArray = [];
            let adminDetails = {};

            if (eachSuperAdminDetails.payment !== undefined) {
              if (eachSuperAdminDetails.payment.maxMulti !== undefined) {
                maxMulti = eachSuperAdminDetails.payment.maxMulti;
              }
            }

            for (const member in members) {
              if (members[member].memberEmail === auth.currentUser.email) {
                const superAdminId = eachSuperAdmin.key;
                const isSuperAdmin =
                  superAdminId === auth.currentUser.uid ? true : false;

                fire
                  .database()
                  .ref("groupAccounts/" + superAdminId + "/members")
                  .once("value")
                  .then((snapshot) => {
                    if (snapshot.exists()) {
                      snapshot.forEach((eachSnapshot) => {
                        const eachSnapshotDetail = eachSnapshot.val();
                        const memberEmail = eachSnapshotDetail.memberEmail;
                        const isAdmin = eachSnapshotDetail.isAdmin;
                        const isSuperAdmin = eachSnapshotDetail.isSuperAdmin;

                        if (isAdmin) {
                          fire
                            .database()
                            .ref("registeredIndustrialUsersOnPlatform")
                            .once("value")
                            .then((snapshot) => {
                              if (snapshot.exists()) {
                                snapshot.forEach((eachUser) => {
                                  const eachUserDetails = eachUser.val();
                                  const adminEmail = eachUserDetails.email;
                                  const adminUid = eachUserDetails.uid;
                                  const adminName = eachUserDetails.name;

                                  if (memberEmail === adminEmail) {
                                    if (adminEmail !== auth.currentUser.email) {
                                      adminDetails = {
                                        adminUid: adminUid,
                                        adminEmail: adminEmail,
                                        adminName: adminName,
                                      };
                                      adminDetailArray.push(adminDetails);
                                    }
                                  }
                                });
                              }
                            });
                        }
                      });
                    }
                  })
                  .then(() => {
                    this.setState({
                      adminDetails: adminDetailArray,
                      loading: false,
                      limitApproval: maxMulti,
                    });
                  });

                fire
                  .database()
                  .ref("GroupManagement/" + superAdminId)
                  .child(auth.currentUser.uid)
                  .once("value")
                  .then((snapshot) => {
                    let groupListArray = [];
                    // let groupDetails = {};
                    snapshot.forEach((group) => {
                      // customLog(user.val());
                      const groupDetails = group.val();
                      // const userName = userDetails.friendName;
                      // const userEmail = userDetails.friendEmail;
                      // friendListArray[userName] = userEmail;
                      // groupDetails = {
                      //   groupName: groupDetails.groupName,
                      //   groupID: groupDetails.groupID
                      // };
                      groupListArray.push(groupDetails);

                      this.setState({
                        groupListArray: groupListArray,
                        loading: false,
                      });
                    });
                  })
                  .catch((err) => customLog(err));
                this.setState({
                  superAdminID: superAdminId,
                  isSuperAdmin: isSuperAdmin,
                });
              }
            }
          });
        }
      });

    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    let groupAccountsPayment = fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("payment");

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((eachSuperAdmin) => {
          if (eachSuperAdmin.key === auth.currentUser.uid) {
            //? if current user = super admin
            const superAdminPayment = eachSuperAdmin.val().payment;
            const superAdminCurrentPlan = superAdminPayment.plan;
            const superAdminMaxMulti = superAdminPayment.maxMulti;
            //? check if the user current subscription isit the old version (old version have no maxMulti)
            if (!superAdminMaxMulti) {
              //? if old subscription, update their maxMulti based on their current subscription plan
              customLog("updating old subscription maxMulti");
              if (superAdminCurrentPlan === 1 || superAdminCurrentPlan === 2) {
                groupAccountsPayment.child("maxMulti").set(4);
              } else if (superAdminCurrentPlan === 3) {
                groupAccountsPayment.child("maxMulti").set(8);
              } else if (superAdminCurrentPlan === 4) {
                //? if custom plan, we have to modify the firebase data directly because their plan might me special (clarify with project manager)
                groupAccountsPayment
                  .child("maxMulti")
                  .set(egeeTouchPlans.egeeTouchplan4.maxMulti);
                // alert(
                //   "Your current plan is out dated, Please contact the support team for help"
                // );
              }
            }
          }
        });
      });

    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          historyArray: tempArray,
          loading: false,
        });
      });

    const historyRef = fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey();

    fire
      .database()
      .ref("lockGroupManagement")
      .child(auth.currentUser.uid)
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        const data = snapshot.val();
        if (data) {
          const lockgroups = Object.values(data);
          // console.log(lockgroups);
          this.setState({
            AlllockGroupArray: lockgroups,
            loading: false,
          });
        } else {
          // console.log("No data found");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    // Turn off the listener to avoid memory leaks
    historyRef.off("value");
  } // end of componentWillMount();

  forceUpdateHandler() {
    this.forceUpdate();
  }
  detectOnLockDropdownChangeEvent2 = (selectedOption) => {
    if (selectedOption !== null) {
      const lockDetails = selectedOption.value;
      // console.log(selectedOption.value);

      this.setState({
        selectedLockgroup: lockDetails,
        isSharedLock: false,
        disabledStateShareLock: false,
      });
    } else {
      this.setState({
        selectedLockgroup: null,
        isSharedLock: false,
        disabledStateShareLock: false,
      });
    }
  };

  detectOnLockDropdownChangeEvent = (selectedOption) => {
    if (selectedOption !== null) {
      const lockDetails = selectedOption.value;
      customLog("lock details " + lockDetails);
      if (
        lockDetails.sharedBy === "" ||
        lockDetails.sharePermissionType === 1
      ) {
        if (lockDetails.ownedBy === auth.currentUser.uid) {
          this.setState({
            selectedLock: lockDetails,
            isSharedLock: false,
            disabledStateShareLock: false,
          });
        } else {
          if (lockDetails.isOfflineLock === false) {
            this.setState({
              selectedLock: lockDetails,
              isSharedLock: true,
              checkboxChecked: false,
              isRetractMode: true,
              disabledStateShareLock: true,
            });
          } else {
            this.setState({
              selectedLock: lockDetails,
              isSharedLock: true,
              checkboxChecked: false,
              disabledStateShareLock: false,
            });
          }
        }
      }
    } else {
      this.setState({
        selectedLock: null,
        isSharedLock: false,
        disabledStateShareLock: false,
      });
    }
  };

  handleRadioTimeAccess() {
    this.setState({
      recurringFullDay: false,
      recurringTimed: true,
    });
  }

  handleRadioFullDay() {
    this.setState({
      recurringFullDay: true,
      recurringTimed: false,
    });
  }
  handleFriendsArray(selectedFriends) {
    // console.log(selectedFriends);
    if (selectedFriends != "") {
      let subtractArrays = [];
      this.state.adminDetails.forEach((o1) => {
        var found = false;
        selectedFriends.forEach((o2) => {
          if (o1.adminEmail === o2.userEmail) {
            found = true;
          }
        });
        if (!found) {
          subtractArrays.push(o1);
        }
      });
      this.setState({
        // showTable: true,
        selectedRecipients: selectedFriends,
        subtractAdminArray: subtractArrays,
      });
    } else {
      customLog(selectedFriends);
      this.setState({
        // showTable: false,
        selectedRecipients: selectedFriends,
        subtractAdminArray: this.state.adminDetails,
      });
    }
  }

  handleGroupsArray(selectedGroups) {
    // console.log(selectedGroups);
    if (selectedGroups != "") {
      var allGroupMembersArray = [];
      for (var i = 0; i < selectedGroups.length; i++) {
        var eachGroup = selectedGroups[i].groupMembers;
        var eachMember = {};
        // var membersArray = [];
        _.map(eachGroup, (member) => {
          eachMember = {
            userName: member.memberName,
            userEmail: member.memberEmail,
          };

          // membersArray.push(eachMember);
          allGroupMembersArray.push(eachMember);
        });
      }
      // console.log(allGroupMembersArray);

      this.setState({
        // showTable: true,
        selectedGroups: selectedGroups,
        selectedRecipients: allGroupMembersArray,
      });
    } else {
      this.setState({
        // showTable: false,
        selectedGroups: [],
        selectedRecipients: [],
      });
    }
  }

  handleChangeMultiSharing(selectedAdministrators) {
    this.setState((prevState) => ({
      showAdminLists: !prevState.showAdminLists,
      disabledStateMultiShare: !prevState.showAdminLists,
      isRetractMode: true,
    }));

    if (selectedAdministrators) {
      if (selectedAdministrators !== true && selectedAdministrators !== false) {
        let subtractArrays = [];
        this.state.userFriendListArray.forEach((o1) => {
          var found = false;
          selectedAdministrators.forEach((o2) => {
            if (o1.userEmail === o2.adminEmail) {
              found = true;
            }
          });
          if (!found) {
            subtractArrays.push(o1);
          }
        });
        this.setState({
          showAdminLists: true,

          selectedAdmins: selectedAdministrators,
          subtractRecipientArray: subtractArrays,
          disabledStateMultiShare: true,
        });
      }
    } else {
      this.setState({
        showAdminLists: false,
        selectedAdmins: [],
        subtractRecipientArray: this.state.userFriendListArray,
        disabledStateMultiShare: false,
      });
    }
  }

  conditionRenderingMultiData(showAdminLists) {
    if (showAdminLists) {
      if (this.state.selectedGroups.length > 0) {
        if (this.state.selectedAdmins.length >= this.state.limitApproval) {
          return this.state.emptyArray;
        } else {
          return this.state.adminDetails;
        }
      } else if (this.state.selectedRecipients.length > 0) {
        if (this.state.selectedAdmins.length >= this.state.limitApproval) {
          return this.state.emptyArray;
        } else {
          return this.state.subtractAdminArray;
        }
      } else {
        if (this.state.selectedAdmins.length >= this.state.limitApproval) {
          return this.state.emptyArray;
        } else {
          return this.state.adminDetails;
        }
      }
    }
  }

  renderDropdown = () => {
    const historylistdata = _.map(this.state.historyArray, (historyData) => {
      const name = historyData.lockName;
      return {
        name: name,
      };
    });

    const typeOfLocks = [
      localizationStrings.myLocksLabel,
      localizationStrings.sharedLocksLabel,
    ];

    let filteredLocklistArray = this.state.locklistArray;

    if (this.state.checkboxChecked5) {
      const lockModel = 10;
      filteredLocklistArray = filteredLocklistArray.filter(
        (lockData) => lockData.Type !== lockModel
      );
    }

    if (this.state.checkboxChecked6) {
      const lockModel = 4;
      filteredLocklistArray = filteredLocklistArray.filter(
        (lockData) => lockData.Type !== lockModel
      );
    }

    return typeOfLocks.map((eachType) => {
      const filteredByOwnership = filteredLocklistArray.filter((lockData) => {
        return (
          (lockData.ownedBy === auth.currentUser.uid &&
            eachType === localizationStrings.myLocksLabel) ||
          (lockData.ownedBy !== auth.currentUser.uid &&
            eachType === localizationStrings.sharedLocksLabel &&
            (lockData.sharedLock || lockData.sharePermissionType === 1))
        );
      });

      const finalFiltered = filteredByOwnership.filter((lockData) => {
        const inHistory = historylistdata.find(
          (item) => item.name === lockData.Name
        );
        return !(inHistory && !this.state.isDisabledSwitch);
      });

      return {
        label: eachType,
        options: finalFiltered.map((lockData) => ({
          value: lockData,
          label: lockData.Name,
        })),
      };
    });
  };
  renderDropdown2 = () => {
    // console.log(this.state.AlllockGroupArray);
    return [
      {
        label: localizationStrings.allLockGroupsLabel,
        options: this.state.AlllockGroupArray.map((lockData) => {
          return {
            value: lockData.name,
            label: lockData.name,
          };
        }),
      },
    ];
  };

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  clearForm() {
    document.getElementById("grantAccessForm").reset();
    this.setState({
      endDate: new Date(new Date().setMinutes(0, 0, 0)),
      startDate: new Date(new Date().setMinutes(0, 0, 0)),
      calendarStartText: "Select your start time",
      calendarEndText: "Select your end time",
      selectedLock: null,
      selectedLockgroup: null,
      radioIndividualChecked: true,
      radioGroupChecked: false,
      radioIndividualLockChecked: true,
      radioGrouplockChecked: false,
      selectedRecipients: [],
      selectedGroups: [],
      showTable: false,
      selectedAdmins: [],
      showAdminLists: false,
      subtractAdminArray: [],
      subtractRecipientArray: [],
      checkboxChecked: false,
      isSharedLock: false,

      // recurring access
      recurringStartText: localizationStrings.startTimeTitle,
      recurringEndText: localizationStrings.endTimeTitle,

      recurringDailyAccessDropDown: "Full-day Access",

      radioNormalChecked: true,
      radioRecurringChecked: false,

      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      recurringFullDay: true,
      recurringTimed: false,

      startTime: null,
      endTime: null,

      // Reset Switch Buttons
      timechecked: false,
      isRetractMode: true,
      OTAMode: false,
      disabledState: false, //for OTA & Sharing Mode
      disabledStateMultiShare: false, //for Multishare & Sharing Mode
      disabledStateShareLock: false, //for OnlineSharedLock & Sharing Mode
    });
  }

  handlewindowShow(event) {
    event.preventDefault();
  }

  eraseAll() {
    window.location.reload(false);
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  showSharedNotification() {
    const isMultipleSendingMode = this.state.isMultipleSendingMode;
    const selectedLock = this.state.selectedLock;
    const seletetedLockgroup = this.state.selectedLockgroup;
    // console.log("notification " + seletetedLockgroup);

    customLog("runned");
    customLog(isMultipleSendingMode);
    if (seletetedLockgroup === null && selectedLock != null) {
      if (isMultipleSendingMode) {
        this.showNotification(
          `${localizationStrings.multiAccess} ${selectedLock.Name} ${localizationStrings.given}`,
          "success",
          5
        );

        this.setState({
          selectedLock: null,
        });
        // this.eraseAll();
      } else {
        this.showNotification(
          `${localizationStrings.singleAccess} ${selectedLock.Name} ${localizationStrings.given}`,
          "success",
          5
        );

        // this.setState({
        //   selectedLock: null
        // });
        // this.eraseAll();
      }
    } else if (seletetedLockgroup != null && selectedLock === null) {
      if (isMultipleSendingMode) {
        this.showNotification(
          `${localizationStrings.multiAccess} ${seletetedLockgroup} ${localizationStrings.given}`,
          "success",
          5
        );

        this.setState({
          selectedLock: null,
        });
        // this.eraseAll();
      } else {
        this.showNotification(
          `${localizationStrings.singleAccess} ${seletetedLockgroup} ${localizationStrings.given}`,
          "success",
          5
        );

        // this.setState({
        //   selectedLock: null
        // });
        // this.eraseAll();
      }
    }
  }

  onSendRemoteAccess() {
    if (this.state.radioIndividualLockChecked && this.state.noShareableLocks) {
      this.showNotification(localizationStrings.noShareableLocks, "error", 5);
      return;
    } else if (
      this.state.radioGrouplockChecked &&
      this.state.noShareableLockGroups
    ) {
      this.showNotification(
        localizationStrings.noShareableLockGroups,
        "error",
        5
      );
      return;
    }
    this.setState({ processing: true });
    const selectedStartDate = parseInt(
      this.state.startDate.getTime() / 1000,
      0
    );
    const AlllockGroupArray = this.state.AlllockGroupArray;
    const selectedEndDate = parseInt(this.state.endDate.getTime() / 1000, 0);
    const currTimeStamp = Math.floor(Date.now() / 1000 - 86400); //minus 1 day so they can share from today
    const selectedLock = this.state.selectedLock; //null
    const selectedLockgroup = this.state.selectedLockgroup;
    const selectedRecipients = this.state.selectedRecipients;
    const selectedGroups = this.state.selectedGroups;
    const retractMode = this.state.isRetractMode;
    const OTAMode = this.state.OTAMode;
    const recurringMode =
      OTAMode || this.state.showAdminLists
        ? false
        : this.state.radioRecurringChecked; //if OTA or Multi share switch === true, it will register as normal sharing type
    const selectedAdmins = this.state.selectedAdmins;
    const showAdminLists = this.state.showAdminLists;
    const superAdminID = this.state.superAdminID;
    const sharePermissionType = this.state.checkboxChecked ? 1 : 0; // by default, non-sharable
    const selectedDays = {
      monday: this.state.recurringCheckMon,
      tuesday: this.state.recurringCheckTue,
      wednesday: this.state.recurringCheckWed,
      thursday: this.state.recurringCheckThu,
      friday: this.state.recurringCheckFri,
      saturday: this.state.recurringCheckSat,
      sunday: this.state.recurringCheckSun,
    };
    const recurringDailyAccess = {
      FullDay: this.state.recurringFullDay,
      TimedAccess: this.state.recurringTimed,
      selectedTime: {
        startTime:
          this.state.startTime === null
            ? null
            : parseInt(
                this.state.startTime.getHours() * 3600 + // Hours to seconds
                this.state.startTime.getMinutes() * 60 + // Minutes to seconds
                  this.state.startTime.getSeconds()
              ),
        endTime:
          this.state.endTime === null
            ? null
            : parseInt(
                this.state.endTime.getHours() * 3600 + // Hours to seconds
                this.state.endTime.getMinutes() * 60 + // Minutes to seconds
                  this.state.endTime.getSeconds()
              ),
      },
    };
    // console.log(selectedLockgroup); //stopped
    // console.log(selectedLock);
    // console.log(selectedRecipients);
    // console.log(selectedGroups);

    // const sharePermissionType = this.state.checkboxChecked ? 0 : 1; // by default, sharable

    // console.log(selectedRecipients);
    // console.log(selectedGroups);
    // console.log(selectedAdmins);

    if (
      this.state.checkboxChecked &&
      selectedLock.ownedBy !== auth.currentUser.uid
    ) {
      //! Admins only can allow sharable lock for their own locks
      this.showNotification(localizationStrings.invalidLock, "error", 5);
      customLog("Invalid Lock");
      customLog("status checkbox " + this.state.checkboxChecked);
      this.setState({ processing: false });
    } else if (
      selectedLock !== null &&
      (selectedRecipients.length > 0 || selectedGroups.length > 0) &&
      !showAdminLists &&
      selectedAdmins.length <= 0
    ) {
      if (
        selectedLock.sharedBy !== "" &&
        selectedLock.sharePermissionType === 1 &&
        selectedLock.shareStartTime > 0 &&
        selectedLock.shareEndTime > 0
      ) {
        //! Time Access Shared Lock
        if (this.state.timechecked) {
          //!Not permanent Share Access
          //? Check if time is valid
          if (
            selectedStartDate < selectedEndDate &&
            selectedStartDate > currTimeStamp
          ) {
            //! Valid start and end date
            //TODO: HERE
            //? Check if it's shared lock with time access, if yes check whether selected start and end date is within the access time period
            if (
              selectedLock.shareStartTime > selectedStartDate ||
              selectedLock.shareEndTime < selectedEndDate
            ) {
              //! selected start and end date not within the access time period
              const start =
                localizationStrings.getLanguage() === "ja"
                  ? new Intl.DateTimeFormat("ja-JP", {
                      year: "numeric",
                    }).format(selectedLock.shareStartTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      month: "numeric",
                    }).format(selectedLock.shareStartTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      day: "numeric",
                    }).format(selectedLock.shareStartTime * 1000) +
                    " " +
                    new Intl.DateTimeFormat("ja-JP", {
                      hourCycle: "h12",
                      hour: "numeric",
                      minute: "2-digit",
                    }).format(selectedLock.shareStartTime * 1000)
                  : new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      // second: "2-digit"
                    }).format(selectedLock.shareStartTime * 1000);

              const end =
                localizationStrings.getLanguage() === "ja"
                  ? new Intl.DateTimeFormat("ja-JP", {
                      year: "numeric",
                    }).format(selectedLock.shareEndTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      month: "numeric",
                    }).format(selectedLock.shareEndTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      day: "numeric",
                    }).format(selectedLock.shareEndTime * 1000) +
                    " " +
                    new Intl.DateTimeFormat("ja-JP", {
                      hourCycle: "h12",
                      hour: "numeric",
                      minute: "2-digit",
                    }).format(selectedLock.shareEndTime * 1000)
                  : new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      // second: "2-digit"
                    }).format(selectedLock.shareEndTime * 1000);

              this.showNotification(
                `${localizationStrings.timedAccessLock1} ${start} ${localizationStrings.timedAccessLock2} ${end} ${localizationStrings.timedAccessLock3}`,
                "error",
                5
              );
              this.setState({ processing: false });
            } else {
              if (recurringMode === true) {
                if (
                  this.state.recurringCheckMon === false &&
                  this.state.recurringCheckTue === false &&
                  this.state.recurringCheckWed === false &&
                  this.state.recurringCheckThu === false &&
                  this.state.recurringCheckFri === false &&
                  this.state.recurringCheckSat === false &&
                  this.state.recurringCheckSun === false
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurring,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else {
                  if (recurringDailyAccess.TimedAccess === true) {
                    if (
                      recurringDailyAccess.selectedTime.startTime === null ||
                      recurringDailyAccess.selectedTime.endTime === null
                    ) {
                      this.showNotification(
                        localizationStrings.invalidRecurringSelectedTime,
                        "error",
                        5
                      );
                      this.setState({ processing: false });
                    } else if (
                      recurringDailyAccess.selectedTime.startTime >
                      recurringDailyAccess.selectedTime.endTime
                    ) {
                      this.showNotification(
                        localizationStrings.invalidRecurringStartTime,
                        "error",
                        5
                      );
                      this.setState({ processing: false });
                    } else {
                      // console.log("Grant ID: 2");
                      grantUserAccess(
                        selectedRecipients,
                        selectedGroups,
                        selectedLockgroup,
                        AlllockGroupArray,
                        selectedLock,
                        selectedDays,
                        selectedStartDate,
                        selectedEndDate,
                        retractMode,
                        OTAMode,
                        recurringMode,
                        // Daily Access
                        recurringDailyAccess,
                        [],
                        showAdminLists,
                        superAdminID,
                        sharePermissionType,
                        this.state.timechecked,
                        this.state.currentLanguage,
                        (callback) => {
                          if (callback.done) {
                            // console.log("callback?" + callback);
                            const userWithoutApp = callback.userWithoutApp;
                            if (
                              userWithoutApp.length !==
                              selectedRecipients.length
                            ) {
                              this.showSharedNotification();
                            }

                            userWithoutApp.forEach((eachUser) => {
                              this.showNotification(
                                `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                "error",
                                5
                              );
                            });
                            this.setState({ processing: false });
                            this.clearForm();
                          }
                        }
                      );
                    }
                  } else {
                    // console.log("Grant ID: 3");
                    grantUserAccess(
                      selectedRecipients,
                      selectedGroups,
                      selectedLockgroup,
                      AlllockGroupArray,
                      selectedLock,
                      selectedDays,
                      selectedStartDate,
                      selectedEndDate,
                      retractMode,
                      OTAMode,
                      recurringMode,
                      // Daily Access
                      recurringDailyAccess,
                      [],
                      showAdminLists,
                      superAdminID,
                      sharePermissionType,
                      this.state.timechecked,
                      this.state.currentLanguage,
                      (callback) => {
                        // console.log("callback?" + callback);
                        if (callback.done) {
                          // console.log("callback?" + callback);
                          const userWithoutApp = callback.userWithoutApp;
                          if (
                            userWithoutApp.length !== selectedRecipients.length
                          ) {
                            this.showSharedNotification();
                          }

                          userWithoutApp.forEach((eachUser) => {
                            this.showNotification(
                              `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                              "error",
                              5
                            );
                          });
                          this.setState({ processing: false });
                          this.clearForm();
                        }
                      }
                    );
                  }
                }
              }
            }

            customLog("Time Shared");
          } else {
            //! Invalid start and end date
            this.showNotification(localizationStrings.invalidTime, "error", 5);
            this.setState({ processing: false });
          }
        } else {
          if (
            recurringMode === true &&
            this.state.recurringCheckMon === false &&
            this.state.recurringCheckTue === false &&
            this.state.recurringCheckWed === false &&
            this.state.recurringCheckThu === false &&
            this.state.recurringCheckFri === false &&
            this.state.recurringCheckSat === false &&
            this.state.recurringCheckSun === false
          ) {
            this.showNotification(
              localizationStrings.invalidRecurring,
              "error",
              5
            );
            this.setState({ processing: false });
          } else {
            if (recurringDailyAccess.TimedAccess === true) {
              if (
                recurringDailyAccess.selectedTime.startTime === null ||
                recurringDailyAccess.selectedTime.endTime === null
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurringSelectedTime,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else if (
                recurringDailyAccess.selectedTime.startTime >
                recurringDailyAccess.selectedTime.endTime
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurringStartTime,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else {
                // console.log("Grant ID: 4");
                grantUserAccess(
                  selectedRecipients,
                  selectedGroups,
                  selectedLockgroup,
                  AlllockGroupArray,
                  selectedLock,
                  selectedDays,
                  selectedStartDate,
                  selectedEndDate,
                  retractMode,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  [],
                  showAdminLists,
                  superAdminID,
                  sharePermissionType,
                  this.state.timechecked,
                  this.state.currentLanguage,
                  (callback) => {
                    if (callback.done) {
                      // console.log("callback?" + callback);
                      const userWithoutApp = callback.userWithoutApp;
                      if (userWithoutApp.length !== selectedRecipients.length) {
                        this.showSharedNotification();
                      }

                      userWithoutApp.forEach((eachUser) => {
                        this.showNotification(
                          `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                          "error",
                          5
                        );
                      });
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  }
                );
              }
            } else {
              //! Permanent Share Access
              customLog("Perm Share");
              // console.log("Grant ID: 5");
              grantUserAccess(
                selectedRecipients,
                selectedGroups,
                selectedLockgroup,
                AlllockGroupArray,
                selectedLock,
                selectedDays,
                selectedLock.shareStartTime,
                selectedLock.shareEndTime,
                retractMode,
                OTAMode,
                recurringMode,
                recurringDailyAccess,
                [],
                showAdminLists,
                superAdminID,
                sharePermissionType,
                this.state.timechecked,
                this.state.currentLanguage,
                (callback) => {
                  if (callback.done) {
                    // console.log("callback?" + callback);
                    const userWithoutApp = callback.userWithoutApp;
                    if (userWithoutApp.length !== selectedRecipients.length) {
                      this.showSharedNotification();
                    }
                    userWithoutApp.forEach((eachUser) => {
                      this.showNotification(
                        `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                        "error",
                        5
                      );
                    });
                    this.setState({ processing: false });
                    this.clearForm();
                  }
                }
              );
            }
          }
        }
      } else {
        if (this.state.timechecked) {
          //!Not permanent Share Access
          //? Check if time is valid
          if (
            selectedStartDate < selectedEndDate &&
            selectedStartDate > currTimeStamp
          ) {
            if (
              recurringMode === true &&
              this.state.recurringCheckMon === false &&
              this.state.recurringCheckTue === false &&
              this.state.recurringCheckWed === false &&
              this.state.recurringCheckThu === false &&
              this.state.recurringCheckFri === false &&
              this.state.recurringCheckSat === false &&
              this.state.recurringCheckSun === false
            ) {
              this.showNotification(
                localizationStrings.invalidRecurring,
                "error",
                5
              );
              this.setState({ processing: false });
            } else {
              if (recurringDailyAccess.TimedAccess === true) {
                if (
                  recurringDailyAccess.selectedTime.startTime === null ||
                  recurringDailyAccess.selectedTime.endTime === null
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurringSelectedTime,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else if (
                  recurringDailyAccess.selectedTime.startTime >
                  recurringDailyAccess.selectedTime.endTime
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurringStartTime,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else {
                  // console.log("Grant ID: 6");

                  // this.showNotification(
                  //   `${localizationStrings.waitMessage}`,
                  //   "warning",
                  //   2
                  // );

                  let sharingMode = "";
                  let recurringDays = [];
                  let duplicateUsers = [];
                  let isGroup = false;

                  if (selectedGroups.length > 0) {
                    isGroup = true;
                  }

                  if (recurringMode) {
                    if (OTAMode && !showAdminLists) {
                      isGroup
                        ? (sharingMode = "OTA-GRP")
                        : (sharingMode = "OTA");
                    } else if (!OTAMode && showAdminLists) {
                      isGroup
                        ? (sharingMode = "MULTI-GRP")
                        : (sharingMode = "MULTI");
                    } else if (OTAMode && showAdminLists) {
                      isGroup
                        ? (sharingMode = "MULTI-OTA-GRP")
                        : (sharingMode = "MULTI-OTA");
                    } else if (recurringDailyAccess.TimedAccess) {
                      isGroup
                        ? (sharingMode = "NORMAL-RECURR-TIMED-GRP")
                        : (sharingMode = "NORMAL-RECURR-TIMED");
                    } else {
                      isGroup
                        ? (sharingMode = "NORMAL-RECURR-GRP")
                        : (sharingMode = "NORMAL-RECURR");
                    }

                    if (selectedDays.sunday === true) {
                      recurringDays.push(0);
                    }
                    if (selectedDays.monday === true) {
                      recurringDays.push(1);
                    }
                    if (selectedDays.tuesday === true) {
                      recurringDays.push(2);
                    }
                    if (selectedDays.wednesday === true) {
                      recurringDays.push(3);
                    }
                    if (selectedDays.thursday === true) {
                      recurringDays.push(4);
                    }
                    if (selectedDays.friday === true) {
                      recurringDays.push(5);
                    }
                    if (selectedDays.saturday === true) {
                      recurringDays.push(6);
                    }
                  } else {
                    if (OTAMode && !showAdminLists) {
                      isGroup
                        ? (sharingMode = "OTA-GRP")
                        : (sharingMode = "OTA");
                    } else if (!OTAMode && showAdminLists) {
                      isGroup
                        ? (sharingMode = "MULTI-GRP")
                        : (sharingMode = "MULTI");
                    } else if (OTAMode && showAdminLists) {
                      isGroup
                        ? (sharingMode = "MULTI-OTA-GRP")
                        : (sharingMode = "MULTI-OTA");
                    } else {
                      isGroup
                        ? (sharingMode = "NORMAL-GRP")
                        : (sharingMode = "NORMAL");
                    }
                  }

                  if (isGroup) {
                    // Check for duplicates in retractableSharingRegistry
                    const promises = selectedGroups.map((group) => {
                      return fire
                        .database()
                        .ref("retractableSharingRegistry")
                        .child(superAdminID)
                        .once("value")
                        .then(async (snapshot) => {
                          const snapshotData = snapshot.val();
                          if (
                            snapshotData &&
                            typeof snapshotData === "object"
                          ) {
                            for (const key of Object.keys(snapshotData)) {
                              const registryData = snapshotData[key];

                              const daysMatch =
                                recurringDays.length === 0 &&
                                registryData.recurringDays === undefined
                                  ? true
                                  : recurringDays.length === 0 &&
                                    registryData.recurringDays !== undefined
                                  ? false
                                  : recurringDays.length > 0 &&
                                    registryData.recurringDays === undefined
                                  ? false
                                  : JSON.stringify(recurringDays) ===
                                    JSON.stringify(registryData.recurringDays);

                              const dailyTimesMatch =
                                recurringDailyAccess.TimedAccess === false &&
                                registryData.selectedRecurringTime === undefined
                                  ? true
                                  : recurringDailyAccess.TimedAccess ===
                                      false &&
                                    registryData.selectedRecurringTime
                                      .startTime === undefined
                                  ? true
                                  : recurringDailyAccess.TimedAccess === true &&
                                    registryData.selectedRecurringTime ===
                                      undefined
                                  ? false
                                  : recurringDailyAccess.TimedAccess === true &&
                                    registryData.selectedRecurringTime
                                      .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.TimedAccess ===
                                      false &&
                                    registryData.selectedRecurringTime !==
                                      undefined
                                  ? registryData.selectedRecurringTime
                                      .startTime === undefined
                                    ? true
                                    : false
                                  : recurringDailyAccess.TimedAccess === true &&
                                    registryData.selectedRecurringTime !==
                                      undefined
                                  ? registryData.selectedRecurringTime
                                      .startTime === undefined
                                    ? false
                                    : recurringDailyAccess.selectedTime
                                        .startTime ===
                                        registryData.selectedRecurringTime
                                          .startTime &&
                                      recurringDailyAccess.selectedTime
                                        .endTime ===
                                        registryData.selectedRecurringTime
                                          .endTime
                                  : false;

                              if (
                                selectedLock.ip45SerialNumber ==
                                  registryData.lockSerial &&
                                group.groupName == registryData.sharedToEmail &&
                                sharingMode == registryData.sharingMode &&
                                selectedStartDate ==
                                  registryData.shareStartTime &&
                                selectedEndDate == registryData.shareEndTime &&
                                daysMatch &&
                                dailyTimesMatch
                              ) {
                                duplicateUsers.push(group.groupName);
                                // console.log(
                                //   "=================================================="
                                // );
                                // console.log(
                                //   "Duplicate found in retractableSharingRegistry"
                                // );
                                // console.log(
                                //   "Lock Serial [ SM: " +
                                //     selectedLock.ip45SerialNumber +
                                //     " = DB: " +
                                //     registryData.lockSerial +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Recipient [ SM: " +
                                //     group.groupName +
                                //     " = DB: " +
                                //     registryData.sharedToEmail +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Sharing Mode [ SM: " +
                                //     sharingMode +
                                //     " = DB: " +
                                //     registryData.sharingMode +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Start Time [ SM: " +
                                //     selectedStartDate +
                                //     " = DB: " +
                                //     registryData.shareStartTime +
                                //     " ]"
                                // );
                                // console.log(
                                //   "End Time [ SM: " +
                                //     selectedEndDate +
                                //     " = DB: " +
                                //     registryData.shareEndTime +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Recurring Days [ SM: " +
                                //     JSON.stringify(recurringDays) +
                                //     " = DB: " +
                                //     (registryData.recurringDays == undefined
                                //       ? "[]"
                                //       : JSON.stringify(
                                //           registryData.recurringDays
                                //         )) +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Daily Start Time [ SM: " +
                                //     recurringDailyAccess.selectedTime.startTime +
                                //     " = DB: " +
                                //     (registryData.selectedRecurringTime ==
                                //     undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .startTime == undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .startTime) +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Daily End Time [ SM: " +
                                //     recurringDailyAccess.selectedTime.endTime +
                                //     " = DB: " +
                                //     (registryData.selectedRecurringTime ==
                                //     undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .endTime == undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .endTime) +
                                //     " ]"
                                // );
                              }
                            }
                          } else {
                            console.error("snapshotData is null or undefined");
                          }
                        });
                    });

                    Promise.all(promises).then(() => {
                      // If no duplicates are found in retractableSharingRegistry for all selected groups, proceed to grant access
                      if (duplicateUsers.length < 1) {
                        // console.log("No duplicates found");
                        grantUserAccess(
                          selectedRecipients,
                          selectedGroups,
                          selectedLockgroup,
                          AlllockGroupArray,
                          selectedLock,
                          selectedDays,
                          selectedStartDate,
                          selectedEndDate,
                          retractMode,
                          OTAMode,
                          recurringMode,
                          recurringDailyAccess,
                          [],
                          showAdminLists,
                          superAdminID,
                          sharePermissionType,
                          this.state.timechecked,
                          this.state.currentLanguage,
                          (callback) => {
                            if (callback.done) {
                              // console.log("callback?" + callback);
                              const userWithoutApp = callback.userWithoutApp;
                              if (
                                userWithoutApp.length !==
                                selectedRecipients.length
                              ) {
                                this.showSharedNotification();
                              }

                              userWithoutApp.forEach((eachUser) => {
                                this.showNotification(
                                  `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                  "error",
                                  5
                                );
                              });
                              this.setState({ processing: false });
                              this.clearForm();
                            }
                          }
                        );
                      } else {
                        // console.log(
                        //   "=================================================="
                        // );
                        for (let i = 0; i < duplicateUsers.length; i++) {
                          // console.log(
                          //   "Identical shared access found for " +
                          //     duplicateUsers[i]
                          // );
                          this.showNotification(
                            `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                            "error",
                            5
                          );
                        }
                        this.setState({ processing: false });
                        this.clearForm();
                      }
                    });
                  } else {
                    // Check for duplicates in retractableSharingRegistry
                    const promises = selectedRecipients.map((recipient) => {
                      return fire
                        .database()
                        .ref("retractableSharingRegistry")
                        .child(superAdminID)
                        .once("value")
                        .then(async (snapshot) => {
                          const snapshotData = snapshot.val();
                          let duplicateFound = false;
                          let recipientEmails = [];
                          let recipientUIDs = [];
                          if (
                            snapshotData &&
                            typeof snapshotData === "object"
                          ) {
                            for (const key of Object.keys(snapshotData)) {
                              const registryData = snapshotData[key];

                              const daysMatch =
                                recurringDays.length === 0 &&
                                registryData.recurringDays === undefined
                                  ? true
                                  : recurringDays.length === 0 &&
                                    registryData.recurringDays !== undefined
                                  ? false
                                  : recurringDays.length > 0 &&
                                    registryData.recurringDays === undefined
                                  ? false
                                  : JSON.stringify(recurringDays) ===
                                    JSON.stringify(registryData.recurringDays);

                              const dailyTimesMatch =
                                recurringDailyAccess.TimedAccess === false &&
                                registryData.selectedRecurringTime === undefined
                                  ? true
                                  : recurringDailyAccess.TimedAccess ===
                                      false &&
                                    registryData.selectedRecurringTime
                                      .startTime === undefined
                                  ? true
                                  : recurringDailyAccess.TimedAccess === true &&
                                    registryData.selectedRecurringTime ===
                                      undefined
                                  ? false
                                  : recurringDailyAccess.TimedAccess === true &&
                                    registryData.selectedRecurringTime
                                      .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.TimedAccess ===
                                      false &&
                                    registryData.selectedRecurringTime !==
                                      undefined
                                  ? registryData.selectedRecurringTime
                                      .startTime === undefined
                                    ? true
                                    : false
                                  : recurringDailyAccess.TimedAccess === true &&
                                    registryData.selectedRecurringTime !==
                                      undefined
                                  ? registryData.selectedRecurringTime
                                      .startTime === undefined
                                    ? false
                                    : recurringDailyAccess.selectedTime
                                        .startTime ===
                                        registryData.selectedRecurringTime
                                          .startTime &&
                                      recurringDailyAccess.selectedTime
                                        .endTime ===
                                        registryData.selectedRecurringTime
                                          .endTime
                                  : false;

                              if (
                                selectedLock.ip45SerialNumber ==
                                  registryData.lockSerial &&
                                recipient.userEmail ==
                                  registryData.sharedToEmail &&
                                sharingMode == registryData.sharingMode &&
                                selectedStartDate ==
                                  registryData.shareStartTime &&
                                selectedEndDate == registryData.shareEndTime &&
                                daysMatch &&
                                dailyTimesMatch
                              ) {
                                duplicateFound = true;
                                duplicateUsers.push(recipient.userEmail);
                                // console.log(
                                //   "=================================================="
                                // );
                                // console.log(
                                //   "Duplicate found in retractableSharingRegistry"
                                // );
                                // console.log(
                                //   "Lock Serial [ SM: " +
                                //     selectedLock.ip45SerialNumber +
                                //     " = DB: " +
                                //     registryData.lockSerial +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Recipient [ SM: " +
                                //     recipient.userEmail +
                                //     " = DB: " +
                                //     registryData.sharedToEmail +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Sharing Mode [ SM: " +
                                //     sharingMode +
                                //     " = DB: " +
                                //     registryData.sharingMode +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Start Time [ SM: " +
                                //     selectedStartDate +
                                //     " = DB: " +
                                //     registryData.shareStartTime +
                                //     " ]"
                                // );
                                // console.log(
                                //   "End Time [ SM: " +
                                //     selectedEndDate +
                                //     " = DB: " +
                                //     registryData.shareEndTime +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Recurring Days [ SM: " +
                                //     JSON.stringify(recurringDays) +
                                //     " = DB: " +
                                //     (registryData.recurringDays == undefined
                                //       ? "[]"
                                //       : JSON.stringify(
                                //           registryData.recurringDays
                                //         )) +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Daily Start Time [ SM: " +
                                //     recurringDailyAccess.selectedTime.startTime +
                                //     " = DB: " +
                                //     (registryData.selectedRecurringTime ==
                                //     undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .startTime == undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .startTime) +
                                //     " ]"
                                // );
                                // console.log(
                                //   "Daily End Time [ SM: " +
                                //     recurringDailyAccess.selectedTime.endTime +
                                //     " = DB: " +
                                //     (registryData.selectedRecurringTime ==
                                //     undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .endTime == undefined
                                //       ? "null"
                                //       : registryData.selectedRecurringTime
                                //           .endTime) +
                                //     " ]"
                                // );
                              } else {
                                if (
                                  !recipientEmails.includes(recipient.userEmail)
                                ) {
                                  recipientEmails.push(recipient.userEmail);
                                }
                              }
                            }
                          } else {
                            console.error("snapshotData is null or undefined");
                          }

                          // If no duplicate found in retractableSharingRegistry, check userLocks
                          if (!duplicateFound && recipientEmails.length > 0) {
                            return Promise.all(
                              recipientEmails.map((recipientEmail) => {
                                return fire
                                  .database()
                                  .ref("registeredUsersOnPlatform")
                                  .orderByValue()
                                  .equalTo(recipientEmail)
                                  .once("value")
                                  .then((snapshot) => {
                                    if (snapshot.exists()) {
                                      snapshot.forEach((eachSnapshot) => {
                                        const recipientUID = eachSnapshot.key;
                                        recipientUIDs.push(recipientUID);
                                      });
                                    }
                                  });
                              })
                            ).then(() => {
                              return Promise.all(
                                recipientUIDs.map((recipientUID) => {
                                  return fire
                                    .database()
                                    .ref("userLocks")
                                    .child(recipientUID)
                                    .once("value")
                                    .then(async (snapshot) => {
                                      const snapshotData = snapshot.val();

                                      if (snapshotData != undefined) {
                                        for (const key of Object.keys(
                                          snapshotData
                                        )) {
                                          const userLocksData =
                                            snapshotData[key];

                                          const daysMatch =
                                            recurringDays.length === 0 &&
                                            userLocksData.recurringDays ===
                                              undefined
                                              ? true
                                              : recurringDays.length === 0 &&
                                                userLocksData.recurringDays !==
                                                  undefined
                                              ? false
                                              : recurringDays.length > 0 &&
                                                userLocksData.recurringDays ===
                                                  undefined
                                              ? false
                                              : JSON.stringify(
                                                  recurringDays
                                                ) ===
                                                JSON.stringify(
                                                  userLocksData.recurringDays
                                                );

                                          const dailyTimesMatch =
                                            recurringDailyAccess.TimedAccess ===
                                              false &&
                                            userLocksData.selectedRecurringTime ===
                                              undefined
                                              ? true
                                              : recurringDailyAccess.TimedAccess ===
                                                  false &&
                                                userLocksData
                                                  .selectedRecurringTime
                                                  .startTime === undefined
                                              ? true
                                              : recurringDailyAccess.TimedAccess ===
                                                  true &&
                                                userLocksData.selectedRecurringTime ===
                                                  undefined
                                              ? false
                                              : recurringDailyAccess.TimedAccess ===
                                                  true &&
                                                userLocksData
                                                  .selectedRecurringTime
                                                  .startTime === undefined
                                              ? false
                                              : recurringDailyAccess.TimedAccess ===
                                                  false &&
                                                userLocksData.selectedRecurringTime !==
                                                  undefined
                                              ? userLocksData
                                                  .selectedRecurringTime
                                                  .startTime === undefined
                                                ? true
                                                : false
                                              : recurringDailyAccess.TimedAccess ===
                                                  true &&
                                                userLocksData.selectedRecurringTime !==
                                                  undefined
                                              ? userLocksData
                                                  .selectedRecurringTime
                                                  .startTime === undefined
                                                ? false
                                                : recurringDailyAccess
                                                    .selectedTime.startTime ===
                                                    userLocksData
                                                      .selectedRecurringTime
                                                      .startTime &&
                                                  recurringDailyAccess
                                                    .selectedTime.endTime ===
                                                    userLocksData
                                                      .selectedRecurringTime
                                                      .endTime
                                              : false;

                                          if (
                                            selectedLock.ip45SerialNumber ==
                                              userLocksData.ip45SerialNumber &&
                                            sharingMode ==
                                              userLocksData.sharingMode &&
                                            selectedStartDate ==
                                              userLocksData.shareStartTime &&
                                            selectedEndDate ==
                                              userLocksData.shareEndTime &&
                                            daysMatch &&
                                            dailyTimesMatch
                                          ) {
                                            duplicateUsers.push(
                                              recipient.userEmail
                                            );
                                            // console.log(
                                            //   "=================================================="
                                            // );
                                            // console.log(
                                            //   "Duplicate found in userLocks"
                                            // );
                                            // console.log(
                                            //   "Lock Serial [ SM: " +
                                            //     selectedLock.ip45SerialNumber +
                                            //     " = DB: " +
                                            //     userLocksData.ip45SerialNumber +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "Recipient [ SM: " +
                                            //     recipient.userEmail +
                                            //     " = DB: " +
                                            //     recipient.userEmail +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "Sharing Mode [ SM: " +
                                            //     sharingMode +
                                            //     " = DB: " +
                                            //     userLocksData.sharingMode +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "Start Time [ SM: " +
                                            //     selectedStartDate +
                                            //     " = DB: " +
                                            //     userLocksData.shareStartTime +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "End Time [ SM: " +
                                            //     selectedEndDate +
                                            //     " = DB: " +
                                            //     userLocksData.shareEndTime +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "Recurring Days [ SM: " +
                                            //     JSON.stringify(recurringDays) +
                                            //     " = DB: " +
                                            //     (userLocksData.recurringDays ==
                                            //     undefined
                                            //       ? "[]"
                                            //       : JSON.stringify(
                                            //           userLocksData.recurringDays
                                            //         )) +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "Daily Start Time [ SM: " +
                                            //     recurringDailyAccess
                                            //       .selectedTime.startTime +
                                            //     " = DB: " +
                                            //     (userLocksData.selectedRecurringTime ==
                                            //     undefined
                                            //       ? "null"
                                            //       : userLocksData
                                            //           .selectedRecurringTime
                                            //           .startTime == undefined
                                            //       ? "null"
                                            //       : userLocksData
                                            //           .selectedRecurringTime
                                            //           .startTime) +
                                            //     " ]"
                                            // );
                                            // console.log(
                                            //   "Daily End Time [ SM: " +
                                            //     recurringDailyAccess
                                            //       .selectedTime.endTime +
                                            //     " = DB: " +
                                            //     (userLocksData.selectedRecurringTime ==
                                            //     undefined
                                            //       ? "null"
                                            //       : userLocksData
                                            //           .selectedRecurringTime
                                            //           .endTime == undefined
                                            //       ? "null"
                                            //       : userLocksData
                                            //           .selectedRecurringTime
                                            //           .endTime) +
                                            //     " ]"
                                            // );
                                          }
                                        }
                                      }
                                    });
                                })
                              );
                            });
                          }
                        });
                    });

                    Promise.all(promises).then(() => {
                      // If no duplicates are found in both retractableSharingRegistry and userLocks for all selected recipients, proceed to grant access
                      if (duplicateUsers.length < 1) {
                        // console.log("No duplicates found");
                        grantUserAccess(
                          selectedRecipients,
                          selectedGroups,
                          selectedLockgroup,
                          AlllockGroupArray,
                          selectedLock,
                          selectedDays,
                          selectedStartDate,
                          selectedEndDate,
                          retractMode,
                          OTAMode,
                          recurringMode,
                          recurringDailyAccess,
                          [],
                          showAdminLists,
                          superAdminID,
                          sharePermissionType,
                          this.state.timechecked,
                          this.state.currentLanguage,
                          (callback) => {
                            if (callback.done) {
                              // console.log("callback?" + callback);
                              const userWithoutApp = callback.userWithoutApp;
                              if (
                                userWithoutApp.length !==
                                selectedRecipients.length
                              ) {
                                this.showSharedNotification();
                              }

                              userWithoutApp.forEach((eachUser) => {
                                this.showNotification(
                                  `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                  "error",
                                  5
                                );
                              });
                              this.setState({ processing: false });
                              this.clearForm();
                            }
                          }
                        );
                      } else {
                        // console.log(
                        //   "=================================================="
                        // );
                        for (let i = 0; i < duplicateUsers.length; i++) {
                          // console.log(
                          //   "Identical shared access found for " +
                          //     duplicateUsers[i]
                          // );
                          this.showNotification(
                            `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                            "error",
                            5
                          );
                        }
                        this.setState({ processing: false });
                        this.clearForm();
                      }
                    });
                  }
                }
              } else {
                //! Valid start and end date
                //TODO: HERE
                // console.log("Grant ID: 7");

                // this.showNotification(
                //   `${localizationStrings.waitMessage}`,
                //   "warning",
                //   2
                // );

                let sharingMode = "";
                let recurringDays = [];
                let duplicateUsers = [];
                let isGroup = false;

                if (selectedGroups.length > 0) {
                  isGroup = true;
                }

                if (recurringMode) {
                  if (OTAMode && !showAdminLists) {
                    isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
                  } else if (!OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-GRP")
                      : (sharingMode = "MULTI");
                  } else if (OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-OTA-GRP")
                      : (sharingMode = "MULTI-OTA");
                  } else if (recurringDailyAccess.TimedAccess) {
                    isGroup
                      ? (sharingMode = "NORMAL-RECURR-TIMED-GRP")
                      : (sharingMode = "NORMAL-RECURR-TIMED");
                  } else {
                    isGroup
                      ? (sharingMode = "NORMAL-RECURR-GRP")
                      : (sharingMode = "NORMAL-RECURR");
                  }

                  if (selectedDays.sunday === true) {
                    recurringDays.push(0);
                  }
                  if (selectedDays.monday === true) {
                    recurringDays.push(1);
                  }
                  if (selectedDays.tuesday === true) {
                    recurringDays.push(2);
                  }
                  if (selectedDays.wednesday === true) {
                    recurringDays.push(3);
                  }
                  if (selectedDays.thursday === true) {
                    recurringDays.push(4);
                  }
                  if (selectedDays.friday === true) {
                    recurringDays.push(5);
                  }
                  if (selectedDays.saturday === true) {
                    recurringDays.push(6);
                  }
                } else {
                  if (OTAMode && !showAdminLists) {
                    isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
                  } else if (!OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-GRP")
                      : (sharingMode = "MULTI");
                  } else if (OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-OTA-GRP")
                      : (sharingMode = "MULTI-OTA");
                  } else {
                    isGroup
                      ? (sharingMode = "NORMAL-GRP")
                      : (sharingMode = "NORMAL");
                  }
                }

                if (isGroup) {
                  // Check for duplicates in retractableSharingRegistry
                  const promises = selectedGroups.map((group) => {
                    return fire
                      .database()
                      .ref("retractableSharingRegistry")
                      .child(superAdminID)
                      .once("value")
                      .then(async (snapshot) => {
                        const snapshotData = snapshot.val();
                        if (snapshotData && typeof snapshotData === "object") {
                          for (const key of Object.keys(snapshotData)) {
                            const registryData = snapshotData[key];

                            const daysMatch =
                              recurringDays.length === 0 &&
                              registryData.recurringDays === undefined
                                ? true
                                : recurringDays.length === 0 &&
                                  registryData.recurringDays !== undefined
                                ? false
                                : recurringDays.length > 0 &&
                                  registryData.recurringDays === undefined
                                ? false
                                : JSON.stringify(recurringDays) ===
                                  JSON.stringify(registryData.recurringDays);

                            const dailyTimesMatch =
                              recurringDailyAccess.TimedAccess === false &&
                              registryData.selectedRecurringTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime ===
                                    undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? true
                                  : false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.selectedTime
                                      .startTime ===
                                      registryData.selectedRecurringTime
                                        .startTime &&
                                    recurringDailyAccess.selectedTime
                                      .endTime ===
                                      registryData.selectedRecurringTime.endTime
                                : false;

                            if (
                              selectedLock.ip45SerialNumber ==
                                registryData.lockSerial &&
                              group.groupName == registryData.sharedToEmail &&
                              sharingMode == registryData.sharingMode &&
                              selectedStartDate ==
                                registryData.shareStartTime &&
                              selectedEndDate == registryData.shareEndTime &&
                              daysMatch &&
                              dailyTimesMatch
                            ) {
                              duplicateUsers.push(group.groupName);
                              // console.log(
                              //   "=================================================="
                              // );
                              // console.log(
                              //   "Duplicate found in retractableSharingRegistry"
                              // );
                              // console.log(
                              //   "Lock Serial [ SM: " +
                              //     selectedLock.ip45SerialNumber +
                              //     " = DB: " +
                              //     registryData.lockSerial +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recipient [ SM: " +
                              //     group.groupName +
                              //     " = DB: " +
                              //     registryData.sharedToEmail +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Sharing Mode [ SM: " +
                              //     sharingMode +
                              //     " = DB: " +
                              //     registryData.sharingMode +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Start Time [ SM: " +
                              //     selectedStartDate +
                              //     " = DB: " +
                              //     registryData.shareStartTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "End Time [ SM: " +
                              //     selectedEndDate +
                              //     " = DB: " +
                              //     registryData.shareEndTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recurring Days [ SM: " +
                              //     JSON.stringify(recurringDays) +
                              //     " = DB: " +
                              //     (registryData.recurringDays == undefined
                              //       ? "[]"
                              //       : JSON.stringify(
                              //           registryData.recurringDays
                              //         )) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily Start Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.startTime +
                              //     " = DB: " +
                              //     (registryData.selectedRecurringTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .startTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .startTime) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily End Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.endTime +
                              //     " = DB: " +
                              //     (registryData.selectedRecurringTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .endTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .endTime) +
                              //     " ]"
                              // );
                            }
                          }
                        } else {
                          console.error("snapshotData is null or undefined");
                        }
                      });
                  });

                  Promise.all(promises).then(() => {
                    // If no duplicates are found in retractableSharingRegistry for all selected groups, proceed to grant access
                    if (duplicateUsers.length < 1) {
                      // console.log("No duplicates found");
                      grantUserAccess(
                        selectedRecipients,
                        selectedGroups,
                        selectedLockgroup,
                        AlllockGroupArray,
                        selectedLock,
                        selectedDays,
                        selectedStartDate,
                        selectedEndDate,
                        retractMode,
                        OTAMode,
                        recurringMode,
                        recurringDailyAccess,
                        [],
                        showAdminLists,
                        superAdminID,
                        sharePermissionType,
                        this.state.timechecked,
                        this.state.currentLanguage,
                        (callback) => {
                          if (callback.done) {
                            // console.log("callback?" + callback);
                            const userWithoutApp = callback.userWithoutApp;
                            if (
                              userWithoutApp.length !==
                              selectedRecipients.length
                            ) {
                              this.showSharedNotification();
                            }

                            userWithoutApp.forEach((eachUser) => {
                              this.showNotification(
                                `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                "error",
                                5
                              );
                            });
                            this.setState({ processing: false });
                            this.clearForm();
                          }
                        }
                      );
                    } else {
                      // console.log(
                      //   "=================================================="
                      // );
                      for (let i = 0; i < duplicateUsers.length; i++) {
                        // console.log(
                        //   "Identical shared access found for " +
                        //     duplicateUsers[i]
                        // );
                        this.showNotification(
                          `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                          "error",
                          5
                        );
                      }
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  });
                } else {
                  // Check for duplicates in retractableSharingRegistry
                  const promises = selectedRecipients.map((recipient) => {
                    return fire
                      .database()
                      .ref("retractableSharingRegistry")
                      .child(superAdminID)
                      .once("value")
                      .then(async (snapshot) => {
                        const snapshotData = snapshot.val();
                        let duplicateFound = false;
                        let recipientEmails = [];
                        let recipientUIDs = [];

                        if (snapshotData && typeof snapshotData === "object") {
                          for (const key of Object.keys(snapshotData)) {
                            const registryData = snapshotData[key];

                            const daysMatch =
                              recurringDays.length === 0 &&
                              registryData.recurringDays === undefined
                                ? true
                                : recurringDays.length === 0 &&
                                  registryData.recurringDays !== undefined
                                ? false
                                : recurringDays.length > 0 &&
                                  registryData.recurringDays === undefined
                                ? false
                                : JSON.stringify(recurringDays) ===
                                  JSON.stringify(registryData.recurringDays);

                            const dailyTimesMatch =
                              recurringDailyAccess.TimedAccess === false &&
                              registryData.selectedRecurringTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime ===
                                    undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? true
                                  : false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.selectedTime
                                      .startTime ===
                                      registryData.selectedRecurringTime
                                        .startTime &&
                                    recurringDailyAccess.selectedTime
                                      .endTime ===
                                      registryData.selectedRecurringTime.endTime
                                : false;

                            if (
                              selectedLock.ip45SerialNumber ==
                                registryData.lockSerial &&
                              recipient.userEmail ==
                                registryData.sharedToEmail &&
                              sharingMode == registryData.sharingMode &&
                              selectedStartDate ==
                                registryData.shareStartTime &&
                              selectedEndDate == registryData.shareEndTime &&
                              daysMatch &&
                              dailyTimesMatch
                            ) {
                              duplicateFound = true;
                              duplicateUsers.push(recipient.userEmail);
                            } else {
                              if (
                                !recipientEmails.includes(recipient.userEmail)
                              ) {
                                recipientEmails.push(recipient.userEmail);
                              }
                            }
                          }
                        } else {
                          console.error("snapshotData is null or undefined");
                        }

                        // If no duplicate found in retractableSharingRegistry, check userLocks
                        if (!duplicateFound && recipientEmails.length > 0) {
                          return Promise.all(
                            recipientEmails.map((recipientEmail) => {
                              return fire
                                .database()
                                .ref("registeredUsersOnPlatform")
                                .orderByValue()
                                .equalTo(recipientEmail)
                                .once("value")
                                .then((snapshot) => {
                                  if (snapshot.exists()) {
                                    snapshot.forEach((eachSnapshot) => {
                                      const recipientUID = eachSnapshot.key;
                                      recipientUIDs.push(recipientUID);
                                    });
                                  }
                                });
                            })
                          ).then(() => {
                            return Promise.all(
                              recipientUIDs.map((recipientUID) => {
                                return fire
                                  .database()
                                  .ref("userLocks")
                                  .child(recipientUID)
                                  .once("value")
                                  .then(async (snapshot) => {
                                    const snapshotData = snapshot.val();

                                    if (snapshotData != undefined) {
                                      for (const key of Object.keys(
                                        snapshotData
                                      )) {
                                        const userLocksData = snapshotData[key];

                                        const daysMatch =
                                          recurringDays.length === 0 &&
                                          userLocksData.recurringDays ===
                                            undefined
                                            ? true
                                            : recurringDays.length === 0 &&
                                              userLocksData.recurringDays !==
                                                undefined
                                            ? false
                                            : recurringDays.length > 0 &&
                                              userLocksData.recurringDays ===
                                                undefined
                                            ? false
                                            : JSON.stringify(recurringDays) ===
                                              JSON.stringify(
                                                userLocksData.recurringDays
                                              );

                                        const dailyTimesMatch =
                                          recurringDailyAccess.TimedAccess ===
                                            false &&
                                          userLocksData.selectedRecurringTime ===
                                            undefined
                                            ? true
                                            : recurringDailyAccess.TimedAccess ===
                                                false &&
                                              userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                            ? true
                                            : recurringDailyAccess.TimedAccess ===
                                                true &&
                                              userLocksData.selectedRecurringTime ===
                                                undefined
                                            ? false
                                            : recurringDailyAccess.TimedAccess ===
                                                true &&
                                              userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                            ? false
                                            : recurringDailyAccess.TimedAccess ===
                                                false &&
                                              userLocksData.selectedRecurringTime !==
                                                undefined
                                            ? userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                              ? true
                                              : false
                                            : recurringDailyAccess.TimedAccess ===
                                                true &&
                                              userLocksData.selectedRecurringTime !==
                                                undefined
                                            ? userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                              ? false
                                              : recurringDailyAccess
                                                  .selectedTime.startTime ===
                                                  userLocksData
                                                    .selectedRecurringTime
                                                    .startTime &&
                                                recurringDailyAccess
                                                  .selectedTime.endTime ===
                                                  userLocksData
                                                    .selectedRecurringTime
                                                    .endTime
                                            : false;

                                        if (
                                          selectedLock.ip45SerialNumber ==
                                            userLocksData.ip45SerialNumber &&
                                          sharingMode ==
                                            userLocksData.sharingMode &&
                                          selectedStartDate ==
                                            userLocksData.shareStartTime &&
                                          selectedEndDate ==
                                            userLocksData.shareEndTime &&
                                          daysMatch &&
                                          dailyTimesMatch
                                        ) {
                                          duplicateUsers.push(
                                            recipient.userEmail
                                          );
                                          // console.log(
                                          //   "=================================================="
                                          // );
                                          // console.log(
                                          //   "Duplicate found in userLocks"
                                          // );
                                          // console.log(
                                          //   "Lock Serial [ SM: " +
                                          //     selectedLock.ip45SerialNumber +
                                          //     " = DB: " +
                                          //     userLocksData.ip45SerialNumber +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Recipient [ SM: " +
                                          //     recipient.userEmail +
                                          //     " = DB: " +
                                          //     recipient.userEmail +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Sharing Mode [ SM: " +
                                          //     sharingMode +
                                          //     " = DB: " +
                                          //     userLocksData.sharingMode +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Start Time [ SM: " +
                                          //     selectedStartDate +
                                          //     " = DB: " +
                                          //     userLocksData.shareStartTime +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "End Time [ SM: " +
                                          //     selectedEndDate +
                                          //     " = DB: " +
                                          //     userLocksData.shareEndTime +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Recurring Days [ SM: " +
                                          //     JSON.stringify(recurringDays) +
                                          //     " = DB: " +
                                          //     (userLocksData.recurringDays ==
                                          //     undefined
                                          //       ? "[]"
                                          //       : JSON.stringify(
                                          //           userLocksData.recurringDays
                                          //         )) +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Daily Start Time [ SM: " +
                                          //     recurringDailyAccess.selectedTime
                                          //       .startTime +
                                          //     " = DB: " +
                                          //     (userLocksData.selectedRecurringTime ==
                                          //     undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .startTime == undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .startTime) +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Daily End Time [ SM: " +
                                          //     recurringDailyAccess.selectedTime
                                          //       .endTime +
                                          //     " = DB: " +
                                          //     (userLocksData.selectedRecurringTime ==
                                          //     undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .endTime == undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .endTime) +
                                          //     " ]"
                                          // );
                                        }
                                      }
                                    }
                                  });
                              })
                            );
                          });
                        }
                      });
                  });

                  Promise.all(promises).then(() => {
                    // If no duplicates are found in both retractableSharingRegistry and userLocks for all selected recipients, proceed to grant access
                    if (duplicateUsers.length < 1) {
                      // console.log("No duplicates found");
                      grantUserAccess(
                        selectedRecipients,
                        selectedGroups,
                        selectedLockgroup,
                        AlllockGroupArray,
                        selectedLock,
                        selectedDays,
                        selectedStartDate,
                        selectedEndDate,
                        retractMode,
                        OTAMode,
                        recurringMode,
                        recurringDailyAccess,
                        [],
                        showAdminLists,
                        superAdminID,
                        sharePermissionType,
                        this.state.timechecked,
                        this.state.currentLanguage,
                        (callback) => {
                          if (callback.done) {
                            // console.log("callback?" + callback);
                            const userWithoutApp = callback.userWithoutApp;
                            if (
                              userWithoutApp.length !==
                              selectedRecipients.length
                            ) {
                              this.showSharedNotification();
                            }

                            userWithoutApp.forEach((eachUser) => {
                              this.showNotification(
                                `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                "error",
                                5
                              );
                            });
                            this.setState({ processing: false });
                            this.clearForm();
                          }
                        }
                      );
                      customLog("Time Shared");
                    } else {
                      // console.log(
                      //   "=================================================="
                      // );
                      for (let i = 0; i < duplicateUsers.length; i++) {
                        // console.log(
                        //   "Identical shared access found for " +
                        //     duplicateUsers[i]
                        // );
                        this.showNotification(
                          `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                          "error",
                          5
                        );
                      }
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  });
                }
              }
            }
          } else {
            //! Invalid start and end date
            this.showNotification(localizationStrings.invalidTime, "error", 5);
            this.setState({ processing: false });
          }
        } else {
          if (
            recurringMode === true &&
            this.state.recurringCheckMon === false &&
            this.state.recurringCheckTue === false &&
            this.state.recurringCheckWed === false &&
            this.state.recurringCheckThu === false &&
            this.state.recurringCheckFri === false &&
            this.state.recurringCheckSat === false &&
            this.state.recurringCheckSun === false
          ) {
            this.showNotification(
              localizationStrings.invalidRecurring,
              "error",
              5
            );
            this.setState({ processing: false });
          } else {
            if (recurringDailyAccess.TimedAccess === true) {
              if (
                recurringDailyAccess.selectedTime.startTime === null ||
                recurringDailyAccess.selectedTime.endTime === null
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurringSelectedTime,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else if (
                recurringDailyAccess.selectedTime.startTime >
                recurringDailyAccess.selectedTime.endTime
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurringStartTime,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else {
                // console.log("Grant ID: 8");
                grantUserAccess(
                  selectedRecipients,
                  selectedGroups,
                  selectedLockgroup,
                  AlllockGroupArray,
                  selectedLock,
                  selectedDays,
                  selectedStartDate,
                  selectedEndDate,
                  retractMode,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  [],
                  showAdminLists,
                  superAdminID,
                  sharePermissionType,
                  this.state.timechecked,
                  this.state.currentLanguage,
                  (callback) => {
                    if (callback.done) {
                      // console.log("callback?" + callback);
                      const userWithoutApp = callback.userWithoutApp;
                      if (userWithoutApp.length !== selectedRecipients.length) {
                        this.showSharedNotification();
                      }

                      userWithoutApp.forEach((eachUser) => {
                        this.showNotification(
                          `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                          "error",
                          5
                        );
                      });
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  }
                );
              }
            } else {
              //! Permanent Share Access
              customLog("Perm Share");

              // console.log("Grant ID: 9");

              // this.showNotification(
              //   `${localizationStrings.waitMessage}`,
              //   "warning",
              //   2
              // );

              let sharingMode = "";
              let recurringDays = [];
              let duplicateUsers = [];
              let isGroup = false;

              if (selectedGroups.length > 0) {
                isGroup = true;
              }

              if (recurringMode) {
                if (OTAMode && !showAdminLists) {
                  isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
                } else if (!OTAMode && showAdminLists) {
                  isGroup
                    ? (sharingMode = "MULTI-GRP")
                    : (sharingMode = "MULTI");
                } else if (OTAMode && showAdminLists) {
                  isGroup
                    ? (sharingMode = "MULTI-OTA-GRP")
                    : (sharingMode = "MULTI-OTA");
                } else if (recurringDailyAccess.TimedAccess) {
                  isGroup
                    ? (sharingMode = "NORMAL-RECURR-TIMED-GRP")
                    : (sharingMode = "NORMAL-RECURR-TIMED");
                } else {
                  isGroup
                    ? (sharingMode = "NORMAL-RECURR-GRP")
                    : (sharingMode = "NORMAL-RECURR");
                }

                if (selectedDays.sunday === true) {
                  recurringDays.push(0);
                }
                if (selectedDays.monday === true) {
                  recurringDays.push(1);
                }
                if (selectedDays.tuesday === true) {
                  recurringDays.push(2);
                }
                if (selectedDays.wednesday === true) {
                  recurringDays.push(3);
                }
                if (selectedDays.thursday === true) {
                  recurringDays.push(4);
                }
                if (selectedDays.friday === true) {
                  recurringDays.push(5);
                }
                if (selectedDays.saturday === true) {
                  recurringDays.push(6);
                }
              } else {
                if (OTAMode && !showAdminLists) {
                  isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
                } else if (!OTAMode && showAdminLists) {
                  isGroup
                    ? (sharingMode = "MULTI-GRP")
                    : (sharingMode = "MULTI");
                } else if (OTAMode && showAdminLists) {
                  isGroup
                    ? (sharingMode = "MULTI-OTA-GRP")
                    : (sharingMode = "MULTI-OTA");
                } else {
                  isGroup
                    ? (sharingMode = "NORMAL-GRP")
                    : (sharingMode = "NORMAL");
                }
              }

              if (isGroup) {
                // Check for duplicates in retractableSharingRegistry
                const promises = selectedGroups.map((group) => {
                  return fire
                    .database()
                    .ref("retractableSharingRegistry")
                    .child(superAdminID)
                    .once("value")
                    .then(async (snapshot) => {
                      const snapshotData = snapshot.val();
                      if (snapshotData && typeof snapshotData === "object") {
                        for (const key of Object.keys(snapshotData)) {
                          const registryData = snapshotData[key];

                          const daysMatch =
                            recurringDays.length === 0 &&
                            registryData.recurringDays === undefined
                              ? true
                              : recurringDays.length === 0 &&
                                registryData.recurringDays !== undefined
                              ? false
                              : recurringDays.length > 0 &&
                                registryData.recurringDays === undefined
                              ? false
                              : JSON.stringify(recurringDays) ===
                                JSON.stringify(registryData.recurringDays);

                          const dailyTimesMatch =
                            recurringDailyAccess.TimedAccess === false &&
                            registryData.selectedRecurringTime === undefined
                              ? true
                              : recurringDailyAccess.TimedAccess === false &&
                                registryData.selectedRecurringTime.startTime ===
                                  undefined
                              ? true
                              : recurringDailyAccess.TimedAccess === true &&
                                registryData.selectedRecurringTime === undefined
                              ? false
                              : recurringDailyAccess.TimedAccess === true &&
                                registryData.selectedRecurringTime.startTime ===
                                  undefined
                              ? false
                              : recurringDailyAccess.TimedAccess === false &&
                                registryData.selectedRecurringTime !== undefined
                              ? registryData.selectedRecurringTime.startTime ===
                                undefined
                                ? true
                                : false
                              : recurringDailyAccess.TimedAccess === true &&
                                registryData.selectedRecurringTime !== undefined
                              ? registryData.selectedRecurringTime.startTime ===
                                undefined
                                ? false
                                : recurringDailyAccess.selectedTime
                                    .startTime ===
                                    registryData.selectedRecurringTime
                                      .startTime &&
                                  recurringDailyAccess.selectedTime.endTime ===
                                    registryData.selectedRecurringTime.endTime
                              : false;

                          if (
                            selectedLock.ip45SerialNumber ==
                              registryData.lockSerial &&
                            group.groupName == registryData.sharedToEmail &&
                            sharingMode == registryData.sharingMode &&
                            registryData.shareStartTime == 0 &&
                            registryData.shareEndTime == 0 &&
                            daysMatch &&
                            dailyTimesMatch
                          ) {
                            duplicateUsers.push(group.groupName);
                            // console.log(
                            //   "=================================================="
                            // );
                            // console.log(
                            //   "Duplicate found in retractableSharingRegistry"
                            // );
                            // console.log(
                            //   "Lock Serial [ SM: " +
                            //     selectedLock.ip45SerialNumber +
                            //     " = DB: " +
                            //     registryData.lockSerial +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Recipient [ SM: " +
                            //     group.groupName +
                            //     " = DB: " +
                            //     registryData.sharedToEmail +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Sharing Mode [ SM: " +
                            //     sharingMode +
                            //     " = DB: " +
                            //     registryData.sharingMode +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Start Time [ SM: 0 = DB: " +
                            //     registryData.shareStartTime +
                            //     " ]"
                            // );
                            // console.log(
                            //   "End Time [ SM: 0 = DB: " +
                            //     registryData.shareEndTime +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Recurring Days [ SM: " +
                            //     JSON.stringify(recurringDays) +
                            //     " = DB: " +
                            //     (registryData.recurringDays == undefined
                            //       ? "[]"
                            //       : JSON.stringify(registryData.recurringDays)) +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Daily Start Time [ SM: " +
                            //     recurringDailyAccess.selectedTime.startTime +
                            //     " = DB: " +
                            //     (registryData.selectedRecurringTime == undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime
                            //           .startTime == undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime
                            //           .startTime) +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Daily End Time [ SM: " +
                            //     recurringDailyAccess.selectedTime.endTime +
                            //     " = DB: " +
                            //     (registryData.selectedRecurringTime == undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime.endTime ==
                            //         undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime.endTime) +
                            //     " ]"
                            // );
                          }
                        }
                      } else {
                        console.error("snapshotData is null or undefined");
                      }
                    });
                });

                Promise.all(promises).then(() => {
                  // If no duplicates are found in retractableSharingRegistry for all selected groups, proceed to grant access
                  if (duplicateUsers.length < 1) {
                    // console.log("No duplicates found");
                    grantUserAccess(
                      selectedRecipients,
                      selectedGroups,
                      selectedLockgroup,
                      AlllockGroupArray,
                      selectedLock,
                      selectedDays,
                      0,
                      0,
                      retractMode,
                      OTAMode,
                      recurringMode,
                      recurringDailyAccess,
                      [],
                      showAdminLists,
                      superAdminID,
                      sharePermissionType,
                      this.state.timechecked,
                      this.state.currentLanguage,
                      (callback) => {
                        if (callback.done) {
                          // console.log("callback?" + callback);
                          const userWithoutApp = callback.userWithoutApp;
                          if (
                            userWithoutApp.length !== selectedRecipients.length
                          ) {
                            this.showSharedNotification();
                          }
                          userWithoutApp.forEach((eachUser) => {
                            this.showNotification(
                              `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                              "error",
                              5
                            );
                          });
                          this.setState({ processing: false });
                          this.clearForm();
                        }
                      }
                    );
                  } else {
                    // console.log(
                    //   "=================================================="
                    // );
                    for (let i = 0; i < duplicateUsers.length; i++) {
                      // console.log(
                      //   "Identical shared access found for " + duplicateUsers[i]
                      // );
                      this.showNotification(
                        `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                        "error",
                        5
                      );
                    }
                    this.setState({ processing: false });
                    this.clearForm();
                  }
                });
              } else {
                // Check for duplicates in retractableSharingRegistry
                const promises = selectedRecipients.map((recipient) => {
                  return fire
                    .database()
                    .ref("retractableSharingRegistry")
                    .child(superAdminID)
                    .once("value")
                    .then(async (snapshot) => {
                      const snapshotData = snapshot.val();
                      if (!snapshotData) return; // ⛑️ prevent crash when no data
                      let duplicateFound = false;
                      let recipientEmails = [];
                      let recipientUIDs = [];
                      if (snapshotData && typeof snapshotData === "object") {
                        for (const key of Object.keys(snapshotData)) {
                          const registryData = snapshotData[key];

                          const daysMatch =
                            recurringDays.length === 0 &&
                            registryData.recurringDays === undefined
                              ? true
                              : recurringDays.length === 0 &&
                                registryData.recurringDays !== undefined
                              ? false
                              : recurringDays.length > 0 &&
                                registryData.recurringDays === undefined
                              ? false
                              : JSON.stringify(recurringDays) ===
                                JSON.stringify(registryData.recurringDays);

                          const dailyTimesMatch =
                            recurringDailyAccess.TimedAccess === false &&
                            registryData.selectedRecurringTime === undefined
                              ? true
                              : recurringDailyAccess.TimedAccess === false &&
                                registryData.selectedRecurringTime.startTime ===
                                  undefined
                              ? true
                              : recurringDailyAccess.TimedAccess === true &&
                                registryData.selectedRecurringTime === undefined
                              ? false
                              : recurringDailyAccess.TimedAccess === true &&
                                registryData.selectedRecurringTime.startTime ===
                                  undefined
                              ? false
                              : recurringDailyAccess.TimedAccess === false &&
                                registryData.selectedRecurringTime !== undefined
                              ? registryData.selectedRecurringTime.startTime ===
                                undefined
                                ? true
                                : false
                              : recurringDailyAccess.TimedAccess === true &&
                                registryData.selectedRecurringTime !== undefined
                              ? registryData.selectedRecurringTime.startTime ===
                                undefined
                                ? false
                                : recurringDailyAccess.selectedTime
                                    .startTime ===
                                    registryData.selectedRecurringTime
                                      .startTime &&
                                  recurringDailyAccess.selectedTime.endTime ===
                                    registryData.selectedRecurringTime.endTime
                              : false;

                          if (
                            selectedLock.ip45SerialNumber ==
                              registryData.lockSerial &&
                            recipient.userEmail == registryData.sharedToEmail &&
                            sharingMode == registryData.sharingMode &&
                            registryData.shareStartTime == 0 &&
                            registryData.shareEndTime == 0 &&
                            daysMatch &&
                            dailyTimesMatch
                          ) {
                            duplicateFound = true;
                            duplicateUsers.push(recipient.userEmail);
                            // console.log(
                            //   "=================================================="
                            // );
                            // console.log(
                            //   "Duplicate found in retractableSharingRegistry"
                            // );
                            // console.log(
                            //   "Lock Serial [ SM: " +
                            //     selectedLock.ip45SerialNumber +
                            //     " = DB: " +
                            //     registryData.lockSerial +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Recipient [ SM: " +
                            //     recipient.userEmail +
                            //     " = DB: " +
                            //     registryData.sharedToEmail +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Sharing Mode [ SM: " +
                            //     sharingMode +
                            //     " = DB: " +
                            //     registryData.sharingMode +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Start Time [ SM: 0 = DB: " +
                            //     registryData.shareStartTime +
                            //     " ]"
                            // );
                            // console.log(
                            //   "End Time [ SM: 0 = DB: " +
                            //     registryData.shareEndTime +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Recurring Days [ SM: " +
                            //     JSON.stringify(recurringDays) +
                            //     " = DB: " +
                            //     (registryData.recurringDays == undefined
                            //       ? "[]"
                            //       : JSON.stringify(registryData.recurringDays)) +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Daily Start Time [ SM: " +
                            //     recurringDailyAccess.selectedTime.startTime +
                            //     " = DB: " +
                            //     (registryData.selectedRecurringTime == undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime
                            //           .startTime == undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime
                            //           .startTime) +
                            //     " ]"
                            // );
                            // console.log(
                            //   "Daily End Time [ SM: " +
                            //     recurringDailyAccess.selectedTime.endTime +
                            //     " = DB: " +
                            //     (registryData.selectedRecurringTime == undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime.endTime ==
                            //         undefined
                            //       ? "null"
                            //       : registryData.selectedRecurringTime.endTime) +
                            //     " ]"
                            // );
                          } else {
                            if (
                              !recipientEmails.includes(recipient.userEmail)
                            ) {
                              recipientEmails.push(recipient.userEmail);
                            }
                          }
                        }
                      } else {
                        console.error("snapshotData is null or undefined");
                      }

                      // If no duplicate found in retractableSharingRegistry, check userLocks
                      if (!duplicateFound && recipientEmails.length > 0) {
                        return Promise.all(
                          recipientEmails.map((recipientEmail) => {
                            return fire
                              .database()
                              .ref("registeredUsersOnPlatform")
                              .orderByValue()
                              .equalTo(recipientEmail)
                              .once("value")
                              .then((snapshot) => {
                                if (snapshot.exists()) {
                                  snapshot.forEach((eachSnapshot) => {
                                    const recipientUID = eachSnapshot.key;
                                    recipientUIDs.push(recipientUID);
                                  });
                                }
                              });
                          })
                        ).then(() => {
                          return Promise.all(
                            recipientUIDs.map((recipientUID) => {
                              return fire
                                .database()
                                .ref("userLocks")
                                .child(recipientUID)
                                .once("value")
                                .then((snapshot) => {
                                  const snapshotData = snapshot.val();

                                  if (snapshotData != undefined) {
                                    for (const key of Object.keys(
                                      snapshotData
                                    )) {
                                      const userLocksData = snapshotData[key];

                                      const daysMatch =
                                        recurringDays.length === 0 &&
                                        userLocksData.recurringDays ===
                                          undefined
                                          ? true
                                          : recurringDays.length === 0 &&
                                            userLocksData.recurringDays !==
                                              undefined
                                          ? false
                                          : recurringDays.length > 0 &&
                                            userLocksData.recurringDays ===
                                              undefined
                                          ? false
                                          : JSON.stringify(recurringDays) ===
                                            JSON.stringify(
                                              userLocksData.recurringDays
                                            );

                                      const dailyTimesMatch =
                                        recurringDailyAccess.TimedAccess ===
                                          false &&
                                        userLocksData.selectedRecurringTime ===
                                          undefined
                                          ? true
                                          : recurringDailyAccess.TimedAccess ===
                                              false &&
                                            userLocksData.selectedRecurringTime
                                              .startTime === undefined
                                          ? true
                                          : recurringDailyAccess.TimedAccess ===
                                              true &&
                                            userLocksData.selectedRecurringTime ===
                                              undefined
                                          ? false
                                          : recurringDailyAccess.TimedAccess ===
                                              true &&
                                            userLocksData.selectedRecurringTime
                                              .startTime === undefined
                                          ? false
                                          : recurringDailyAccess.TimedAccess ===
                                              false &&
                                            userLocksData.selectedRecurringTime !==
                                              undefined
                                          ? userLocksData.selectedRecurringTime
                                              .startTime === undefined
                                            ? true
                                            : false
                                          : recurringDailyAccess.TimedAccess ===
                                              true &&
                                            userLocksData.selectedRecurringTime !==
                                              undefined
                                          ? userLocksData.selectedRecurringTime
                                              .startTime === undefined
                                            ? false
                                            : recurringDailyAccess.selectedTime
                                                .startTime ===
                                                userLocksData
                                                  .selectedRecurringTime
                                                  .startTime &&
                                              recurringDailyAccess.selectedTime
                                                .endTime ===
                                                userLocksData
                                                  .selectedRecurringTime.endTime
                                          : false;

                                      if (
                                        selectedLock.ip45SerialNumber ==
                                          userLocksData.ip45SerialNumber &&
                                        sharingMode ==
                                          userLocksData.sharingMode &&
                                        userLocksData.shareStartTime == 0 &&
                                        userLocksData.shareEndTime == 0 &&
                                        daysMatch &&
                                        dailyTimesMatch
                                      ) {
                                        duplicateUsers.push(
                                          recipient.userEmail
                                        );
                                        // console.log(
                                        //   "=================================================="
                                        // );
                                        // console.log(
                                        //   "Duplicate found in userLocks"
                                        // );
                                        // console.log(
                                        //   "Lock Serial [ SM: " +
                                        //     selectedLock.ip45SerialNumber +
                                        //     " = DB: " +
                                        //     userLocksData.ip45SerialNumber +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "Recipient [ SM: " +
                                        //     recipient.userEmail +
                                        //     " = DB: " +
                                        //     recipient.userEmail +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "Sharing Mode [ SM: " +
                                        //     sharingMode +
                                        //     " = DB: " +
                                        //     userLocksData.sharingMode +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "Start Time [ SM: 0 = DB: " +
                                        //     userLocksData.shareStartTime +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "End Time [ SM: 0 = DB: " +
                                        //     userLocksData.shareEndTime +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "Recurring Days [ SM: " +
                                        //     JSON.stringify(recurringDays) +
                                        //     " = DB: " +
                                        //     (userLocksData.recurringDays ==
                                        //     undefined
                                        //       ? "[]"
                                        //       : JSON.stringify(
                                        //           userLocksData.recurringDays
                                        //         )) +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "Daily Start Time [ SM: " +
                                        //     recurringDailyAccess.selectedTime
                                        //       .startTime +
                                        //     " = DB: " +
                                        //     (userLocksData.selectedRecurringTime ==
                                        //     undefined
                                        //       ? "null"
                                        //       : userLocksData
                                        //           .selectedRecurringTime
                                        //           .startTime == undefined
                                        //       ? "null"
                                        //       : userLocksData
                                        //           .selectedRecurringTime
                                        //           .startTime) +
                                        //     " ]"
                                        // );
                                        // console.log(
                                        //   "Daily End Time [ SM: " +
                                        //     recurringDailyAccess.selectedTime
                                        //       .endTime +
                                        //     " = DB: " +
                                        //     (userLocksData.selectedRecurringTime ==
                                        //     undefined
                                        //       ? "null"
                                        //       : userLocksData
                                        //           .selectedRecurringTime
                                        //           .endTime == undefined
                                        //       ? "null"
                                        //       : userLocksData
                                        //           .selectedRecurringTime
                                        //           .endTime) +
                                        //     " ]"
                                        // );
                                      }
                                    }
                                  }
                                });
                            })
                          );
                        });
                      }
                    });
                });

                Promise.all(promises).then(() => {
                  // If no duplicates are found in both retractableSharingRegistry and userLocks for all selected recipients, proceed to grant access
                  if (duplicateUsers.length < 1) {
                    // console.log("No duplicates found");
                    grantUserAccess(
                      selectedRecipients,
                      selectedGroups,
                      selectedLockgroup,
                      AlllockGroupArray,
                      selectedLock,
                      selectedDays,
                      0,
                      0,
                      retractMode,
                      OTAMode,
                      recurringMode,
                      recurringDailyAccess,
                      [],
                      showAdminLists,
                      superAdminID,
                      sharePermissionType,
                      this.state.timechecked,
                      this.state.currentLanguage,
                      (callback) => {
                        if (callback.done) {
                          // console.log("callback?" + callback);
                          const userWithoutApp = callback.userWithoutApp;
                          if (
                            userWithoutApp.length !== selectedRecipients.length
                          ) {
                            this.showSharedNotification();
                          }
                          userWithoutApp.forEach((eachUser) => {
                            this.showNotification(
                              `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                              "error",
                              5
                            );
                          });
                          this.setState({ processing: false });
                          this.clearForm();
                        }
                      }
                    );
                  } else {
                    // console.log(
                    //   "=================================================="
                    // );
                    for (let i = 0; i < duplicateUsers.length; i++) {
                      // console.log(
                      //   "Identical shared access found for " + duplicateUsers[i]
                      // );
                      this.showNotification(
                        `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                        "error",
                        5
                      );
                    }
                    this.setState({ processing: false });
                    this.clearForm();
                  }
                });
              }
            }
          }
        }
      }
    } else if (
      selectedLock !== null &&
      (selectedRecipients.length > 0 || selectedGroups.length > 0) &&
      showAdminLists &&
      selectedAdmins.length > 0 &&
      selectedRecipients !== selectedAdmins
    ) {
      if (
        selectedLock.sharedBy !== "" &&
        selectedLock.sharePermissionType === 1 &&
        selectedLock.shareStartTime > 0 &&
        selectedLock.shareEndTime > 0
      ) {
        //! Time Access Shared Lock
        if (this.state.timechecked) {
          //!Not permanent Share Access
          //? Check if time is valid
          if (
            selectedStartDate < selectedEndDate &&
            selectedStartDate > currTimeStamp
          ) {
            //! Valid start and end date
            //TODO: HERE
            //? Check if it's shared lock with time access, if yes check whether selected start and end date is within the access time period
            if (
              selectedLock.shareStartTime > selectedStartDate ||
              selectedLock.shareEndTime < selectedEndDate
            ) {
              //! selected start and end date not within the access time period
              const start =
                localizationStrings.getLanguage() === "ja"
                  ? new Intl.DateTimeFormat("ja-JP", {
                      year: "numeric",
                    }).format(selectedLock.shareStartTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      month: "numeric",
                    }).format(selectedLock.shareStartTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      day: "numeric",
                    }).format(selectedLock.shareStartTime * 1000) +
                    " " +
                    new Intl.DateTimeFormat("ja-JP", {
                      hourCycle: "h12",
                      hour: "numeric",
                      minute: "2-digit",
                    }).format(selectedLock.shareStartTime * 1000)
                  : new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      // second: "2-digit"
                    }).format(selectedLock.shareStartTime * 1000);

              const end =
                localizationStrings.getLanguage() === "ja"
                  ? new Intl.DateTimeFormat("ja-JP", {
                      year: "numeric",
                    }).format(selectedLock.shareEndTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      month: "numeric",
                    }).format(selectedLock.shareEndTime * 1000) +
                    new Intl.DateTimeFormat("ja-JP", {
                      day: "numeric",
                    }).format(selectedLock.shareEndTime * 1000) +
                    " " +
                    new Intl.DateTimeFormat("ja-JP", {
                      hourCycle: "h12",
                      hour: "numeric",
                      minute: "2-digit",
                    }).format(selectedLock.shareEndTime * 1000)
                  : new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      // second: "2-digit"
                    }).format(selectedLock.shareEndTime * 1000);

              this.showNotification(
                `${localizationStrings.timedAccessLock1} ${start} ${localizationStrings.timedAccessLock2} ${end} ${localizationStrings.timedAccessLock3}`,
                "error",
                5
              );
              this.setState({ processing: false });
            } else {
              if (
                recurringMode === true &&
                this.state.recurringCheckMon === false &&
                this.state.recurringCheckTue === false &&
                this.state.recurringCheckWed === false &&
                this.state.recurringCheckThu === false &&
                this.state.recurringCheckFri === false &&
                this.state.recurringCheckSat === false &&
                this.state.recurringCheckSun === false
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurring,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else {
                if (recurringDailyAccess.TimedAccess === true) {
                  if (
                    recurringDailyAccess.selectedTime.startTime === null ||
                    recurringDailyAccess.selectedTime.endTime === null
                  ) {
                    this.showNotification(
                      localizationStrings.invalidRecurringSelectedTime,
                      "error",
                      5
                    );
                    this.setState({ processing: false });
                  } else if (
                    recurringDailyAccess.selectedTime.startTime >
                    recurringDailyAccess.selectedTime.endTime
                  ) {
                    this.showNotification(
                      localizationStrings.invalidRecurringStartTime,
                      "error",
                      5
                    );
                    this.setState({ processing: false });
                  } else {
                    // console.log("Grant ID: 10");
                    grantUserAccess(
                      selectedRecipients,
                      selectedGroups,
                      selectedLockgroup,
                      AlllockGroupArray,
                      selectedLock,
                      selectedDays,
                      selectedStartDate,
                      selectedEndDate,
                      retractMode,
                      OTAMode,
                      recurringMode,
                      recurringDailyAccess,
                      [],
                      showAdminLists,
                      superAdminID,
                      sharePermissionType,
                      this.state.timechecked,
                      this.state.currentLanguage,
                      (callback) => {
                        if (callback.done) {
                          // console.log("callback?" + callback);
                          const userWithoutApp = callback.userWithoutApp;
                          if (
                            userWithoutApp.length !== selectedRecipients.length
                          ) {
                            this.showSharedNotification();
                          }

                          userWithoutApp.forEach((eachUser) => {
                            this.showNotification(
                              `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                              "error",
                              5
                            );
                          });
                          this.setState({ processing: false });
                          this.clearForm();
                        }
                      }
                    );
                  }
                } else {
                  // console.log("Grant ID: 11");
                  grantUserAccess(
                    selectedRecipients,
                    selectedGroups,
                    selectedLockgroup,
                    AlllockGroupArray,
                    selectedLock,
                    selectedDays,
                    selectedStartDate,
                    selectedEndDate,
                    retractMode,
                    OTAMode,
                    recurringMode,
                    recurringDailyAccess,
                    selectedAdmins,
                    showAdminLists,
                    superAdminID,
                    sharePermissionType,
                    this.state.timechecked,
                    this.state.currentLanguage,
                    (callback) => {
                      if (callback.done) {
                        // console.log("callback?" + callback);
                        const userWithoutApp = callback.userWithoutApp;
                        if (
                          userWithoutApp.length !== selectedRecipients.length
                        ) {
                          this.showSharedNotification();
                        }

                        userWithoutApp.forEach((eachUser) => {
                          this.showNotification(
                            `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                            "error",
                            5
                          );
                        });
                        this.setState({ processing: false });
                        this.clearForm();
                      }
                    }
                  );
                }
              }
            }

            customLog("Time Shared");
          } else {
            //! Invalid start and end date
            this.showNotification(localizationStrings.invalidTime, "error", 5);
            this.setState({ processing: false });
          }
        } else {
          if (
            recurringMode === true &&
            this.state.recurringCheckMon === false &&
            this.state.recurringCheckTue === false &&
            this.state.recurringCheckWed === false &&
            this.state.recurringCheckThu === false &&
            this.state.recurringCheckFri === false &&
            this.state.recurringCheckSat === false &&
            this.state.recurringCheckSun === false
          ) {
            this.showNotification(
              localizationStrings.invalidRecurring,
              "error",
              5
            );
            this.setState({ processing: false });
          } else {
            if (recurringDailyAccess.TimedAccess === true) {
              if (
                recurringDailyAccess.selectedTime.startTime === null ||
                recurringDailyAccess.selectedTime.endTime === null
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurringSelectedTime,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else if (
                recurringDailyAccess.selectedTime.startTime >
                recurringDailyAccess.selectedTime.endTime
              ) {
                this.showNotification(
                  localizationStrings.invalidRecurringStartTime,
                  "error",
                  5
                );
                this.setState({ processing: false });
              } else {
                // console.log("Grant ID: 12");
                grantUserAccess(
                  selectedRecipients,
                  selectedGroups,
                  selectedLockgroup,
                  AlllockGroupArray,
                  selectedLock,
                  selectedDays,
                  selectedStartDate,
                  selectedEndDate,
                  retractMode,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  [],
                  showAdminLists,
                  superAdminID,
                  sharePermissionType,
                  this.state.timechecked,
                  this.state.currentLanguage,
                  (callback) => {
                    if (callback.done) {
                      // console.log("callback?" + callback);
                      const userWithoutApp = callback.userWithoutApp;
                      if (userWithoutApp.length !== selectedRecipients.length) {
                        this.showSharedNotification();
                      }

                      userWithoutApp.forEach((eachUser) => {
                        this.showNotification(
                          `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                          "error",
                          5
                        );
                      });
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  }
                );
              }
            } else {
              //! Permanent Share Access
              customLog("Perm Share");
              // console.log("Grant ID: 13");
              grantUserAccess(
                selectedRecipients,
                selectedGroups,
                selectedLockgroup,
                AlllockGroupArray,
                selectedLock,
                selectedDays,
                selectedLock.shareStartTime,
                selectedLock.shareEndTime,
                retractMode,
                OTAMode,
                recurringMode,
                recurringDailyAccess,
                selectedAdmins,
                showAdminLists,
                superAdminID,
                sharePermissionType,
                this.state.timechecked,
                this.state.currentLanguage,
                (callback) => {
                  if (callback.done) {
                    // console.log("callback?" + callback);
                    const userWithoutApp = callback.userWithoutApp;
                    if (userWithoutApp.length !== selectedRecipients.length) {
                      this.showSharedNotification();
                    }
                    userWithoutApp.forEach((eachUser) => {
                      this.showNotification(
                        `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                        "error",
                        5
                      );
                    });
                    this.setState({ processing: false });
                    this.clearForm();
                  }
                }
              );
            }
          }
        }
      } else {
        if (this.state.timechecked) {
          //!Not permanent Share Access
          //? Check if time is valid
          if (
            selectedStartDate < selectedEndDate &&
            selectedStartDate > currTimeStamp
          ) {
            if (
              recurringMode === true &&
              this.state.recurringCheckMon === false &&
              this.state.recurringCheckTue === false &&
              this.state.recurringCheckWed === false &&
              this.state.recurringCheckThu === false &&
              this.state.recurringCheckFri === false &&
              this.state.recurringCheckSat === false &&
              this.state.recurringCheckSun === false
            ) {
              this.showNotification(
                localizationStrings.invalidRecurring,
                "error",
                5
              );
              this.setState({ processing: false });
            } else {
              if (recurringDailyAccess.TimedAccess === true) {
                if (
                  recurringDailyAccess.selectedTime.startTime === null ||
                  recurringDailyAccess.selectedTime.endTime === null
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurringSelectedTime,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else if (
                  recurringDailyAccess.selectedTime.startTime >
                  recurringDailyAccess.selectedTime.endTime
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurringStartTime,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else {
                  // console.log("Grant ID: 14");
                  grantUserAccess(
                    selectedRecipients,
                    selectedGroups,
                    selectedLockgroup,
                    AlllockGroupArray,
                    selectedLock,
                    selectedDays,
                    selectedStartDate,
                    selectedEndDate,
                    retractMode,
                    OTAMode,
                    recurringMode,
                    recurringDailyAccess,
                    [],
                    showAdminLists,
                    superAdminID,
                    sharePermissionType,
                    this.state.timechecked,
                    this.state.currentLanguage,
                    (callback) => {
                      if (callback.done) {
                        // console.log("callback?" + callback);
                        const userWithoutApp = callback.userWithoutApp;
                        if (
                          userWithoutApp.length !== selectedRecipients.length
                        ) {
                          this.showSharedNotification();
                        }

                        userWithoutApp.forEach((eachUser) => {
                          this.showNotification(
                            `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                            "error",
                            5
                          );
                        });
                        this.setState({ processing: false });
                        this.clearForm();
                      }
                    }
                  );
                }
              } else {
                //! Valid start and end date
                //TODO: HERE
                // console.log("Grant ID: 15");
                grantUserAccess(
                  selectedRecipients,
                  selectedGroups,
                  selectedLockgroup,
                  AlllockGroupArray,
                  selectedLock,
                  selectedDays,
                  selectedStartDate,
                  selectedEndDate,
                  retractMode,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  selectedAdmins,
                  showAdminLists,
                  superAdminID,
                  sharePermissionType,
                  this.state.timechecked,
                  this.state.currentLanguage,
                  (callback) => {
                    if (callback.done) {
                      // console.log("callback?" + callback);
                      const userWithoutApp = callback.userWithoutApp;
                      if (userWithoutApp.length !== selectedRecipients.length) {
                        this.showSharedNotification();
                      }

                      userWithoutApp.forEach((eachUser) => {
                        this.showNotification(
                          `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                          "error",
                          5
                        );
                      });
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  }
                );

                customLog("Time Shared");
              }
            }
          } else {
            //! Invalid start and end date
            this.showNotification(localizationStrings.invalidTime, "error", 5);
            this.setState({ processing: false });
          }
        } else {
          if (showAdminLists && selectedAdmins.length <= 0) {
            this.showNotification(localizationStrings.selectAdmin, "error", 5);
            this.setState({ processing: false });
          } else {
            if (
              recurringMode === true &&
              this.state.recurringCheckMon === false &&
              this.state.recurringCheckTue === false &&
              this.state.recurringCheckWed === false &&
              this.state.recurringCheckThu === false &&
              this.state.recurringCheckFri === false &&
              this.state.recurringCheckSat === false &&
              this.state.recurringCheckSun === false
            ) {
              this.showNotification(
                localizationStrings.invalidRecurring,
                "error",
                5
              );
              this.setState({ processing: false });
            } else {
              if (recurringDailyAccess.TimedAccess === true) {
                if (
                  recurringDailyAccess.selectedTime.startTime === null ||
                  recurringDailyAccess.selectedTime.endTime === null
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurringSelectedTime,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else if (
                  recurringDailyAccess.selectedTime.startTime >
                  recurringDailyAccess.selectedTime.endTime
                ) {
                  this.showNotification(
                    localizationStrings.invalidRecurringStartTime,
                    "error",
                    5
                  );
                  this.setState({ processing: false });
                } else {
                  // console.log("Grant ID: 16");
                  grantUserAccess(
                    selectedRecipients,
                    selectedGroups,
                    selectedLockgroup,
                    AlllockGroupArray,
                    selectedLock,
                    selectedDays,
                    selectedStartDate,
                    selectedEndDate,
                    retractMode,
                    OTAMode,
                    recurringMode,
                    recurringDailyAccess,
                    [],
                    showAdminLists,
                    superAdminID,
                    sharePermissionType,
                    this.state.timechecked,
                    this.state.currentLanguage,
                    (callback) => {
                      if (callback.done) {
                        // console.log("callback?" + callback);
                        const userWithoutApp = callback.userWithoutApp;
                        if (
                          userWithoutApp.length !== selectedRecipients.length
                        ) {
                          this.showSharedNotification();
                        }

                        userWithoutApp.forEach((eachUser) => {
                          this.showNotification(
                            `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                            "error",
                            5
                          );
                        });

                        this.setState({ processing: false });
                        this.clearForm();
                      }
                    }
                  );
                }
              } else {
                //! Permanent Share Access
                customLog("Perm Share");

                // console.log("Grant ID: 17");

                // this.showNotification(
                //   `${localizationStrings.waitMessage}`,
                //   "warning",
                //   2
                // );

                let sharingMode = "";
                let recurringDays = [];
                let duplicateUsers = [];
                let isGroup = false;

                if (selectedGroups.length > 0) {
                  isGroup = true;
                }

                if (recurringMode) {
                  if (OTAMode && !showAdminLists) {
                    isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
                  } else if (!OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-GRP")
                      : (sharingMode = "MULTI");
                  } else if (OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-OTA-GRP")
                      : (sharingMode = "MULTI-OTA");
                  } else if (recurringDailyAccess.TimedAccess) {
                    isGroup
                      ? (sharingMode = "NORMAL-RECURR-TIMED-GRP")
                      : (sharingMode = "NORMAL-RECURR-TIMED");
                  } else {
                    isGroup
                      ? (sharingMode = "NORMAL-RECURR-GRP")
                      : (sharingMode = "NORMAL-RECURR");
                  }

                  if (selectedDays.sunday === true) {
                    recurringDays.push(0);
                  }
                  if (selectedDays.monday === true) {
                    recurringDays.push(1);
                  }
                  if (selectedDays.tuesday === true) {
                    recurringDays.push(2);
                  }
                  if (selectedDays.wednesday === true) {
                    recurringDays.push(3);
                  }
                  if (selectedDays.thursday === true) {
                    recurringDays.push(4);
                  }
                  if (selectedDays.friday === true) {
                    recurringDays.push(5);
                  }
                  if (selectedDays.saturday === true) {
                    recurringDays.push(6);
                  }
                } else {
                  if (OTAMode && !showAdminLists) {
                    isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
                  } else if (!OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-GRP")
                      : (sharingMode = "MULTI");
                  } else if (OTAMode && showAdminLists) {
                    isGroup
                      ? (sharingMode = "MULTI-OTA-GRP")
                      : (sharingMode = "MULTI-OTA");
                  } else {
                    isGroup
                      ? (sharingMode = "NORMAL-GRP")
                      : (sharingMode = "NORMAL");
                  }
                }

                if (isGroup) {
                  // Check for duplicates in retractableSharingRegistry
                  const promises = selectedGroups.map((group) => {
                    return fire
                      .database()
                      .ref("retractableSharingRegistry")
                      .child(superAdminID)
                      .once("value")
                      .then(async (snapshot) => {
                        const snapshotData = snapshot.val();
                        if (snapshotData && typeof snapshotData === "object") {
                          for (const key of Object.keys(snapshotData)) {
                            const registryData = snapshotData[key];

                            const daysMatch =
                              recurringDays.length === 0 &&
                              registryData.recurringDays === undefined
                                ? true
                                : recurringDays.length === 0 &&
                                  registryData.recurringDays !== undefined
                                ? false
                                : recurringDays.length > 0 &&
                                  registryData.recurringDays === undefined
                                ? false
                                : JSON.stringify(recurringDays) ===
                                  JSON.stringify(registryData.recurringDays);

                            const dailyTimesMatch =
                              recurringDailyAccess.TimedAccess === false &&
                              registryData.selectedRecurringTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime ===
                                    undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? true
                                  : false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.selectedTime
                                      .startTime ===
                                      registryData.selectedRecurringTime
                                        .startTime &&
                                    recurringDailyAccess.selectedTime
                                      .endTime ===
                                      registryData.selectedRecurringTime.endTime
                                : false;

                            if (
                              selectedLock.ip45SerialNumber ==
                                registryData.lockSerial &&
                              group.groupName == registryData.sharedToEmail &&
                              sharingMode == registryData.sharingMode &&
                              registryData.shareStartTime == 0 &&
                              registryData.shareEndTime == 0 &&
                              daysMatch &&
                              dailyTimesMatch
                            ) {
                              duplicateUsers.push(group.groupName);
                              // console.log(
                              //   "=================================================="
                              // );
                              // console.log(
                              //   "Duplicate found in retractableSharingRegistry"
                              // );
                              // console.log(
                              //   "Lock Serial [ SM: " +
                              //     selectedLock.ip45SerialNumber +
                              //     " = DB: " +
                              //     registryData.lockSerial +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recipient [ SM: " +
                              //     group.groupName +
                              //     " = DB: " +
                              //     registryData.sharedToEmail +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Sharing Mode [ SM: " +
                              //     sharingMode +
                              //     " = DB: " +
                              //     registryData.sharingMode +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Start Time [ SM: 0 = DB: " +
                              //     registryData.shareStartTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "End Time [ SM: 0 = DB: " +
                              //     registryData.shareEndTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recurring Days [ SM: " +
                              //     JSON.stringify(recurringDays) +
                              //     " = DB: " +
                              //     (registryData.recurringDays == undefined
                              //       ? "[]"
                              //       : JSON.stringify(
                              //           registryData.recurringDays
                              //         )) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily Start Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.startTime +
                              //     " = DB: " +
                              //     (registryData.selectedRecurringTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .startTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .startTime) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily End Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.endTime +
                              //     " = DB: " +
                              //     (registryData.selectedRecurringTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .endTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .endTime) +
                              //     " ]"
                              // );
                            }
                          }
                        } else {
                          console.error("snapshotData is null or undefined");
                        }
                      });
                  });

                  Promise.all(promises).then(() => {
                    // If no duplicates are found in retractableSharingRegistry for all selected groups, proceed to grant access
                    if (duplicateUsers.length < 1) {
                      // console.log("No duplicates found");
                      grantUserAccess(
                        selectedRecipients,
                        selectedGroups,
                        selectedLockgroup,
                        AlllockGroupArray,
                        selectedLock,
                        selectedDays,
                        0,
                        0,
                        retractMode,
                        OTAMode,
                        recurringMode,
                        recurringDailyAccess,
                        selectedAdmins,
                        showAdminLists,
                        superAdminID,
                        sharePermissionType,
                        this.state.timechecked,
                        this.state.currentLanguage,
                        (callback) => {
                          if (callback.done) {
                            // console.log("callback?" + callback);
                            const userWithoutApp = callback.userWithoutApp;
                            if (
                              userWithoutApp.length !==
                              selectedRecipients.length
                            ) {
                              this.showSharedNotification();
                            }
                            userWithoutApp.forEach((eachUser) => {
                              this.showNotification(
                                `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                "error",
                                5
                              );
                            });
                            this.setState({ processing: false });
                            this.clearForm();
                          }
                        }
                      );
                    } else {
                      // console.log(
                      //   "=================================================="
                      // );
                      for (let i = 0; i < duplicateUsers.length; i++) {
                        // console.log(
                        //   "Identical shared access found for " +
                        //     duplicateUsers[i]
                        // );
                        this.showNotification(
                          `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                          "error",
                          5
                        );
                      }
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  });
                } else {
                  // Check for duplicates in retractableSharingRegistry
                  const promises = selectedRecipients.map((recipient) => {
                    return fire
                      .database()
                      .ref("retractableSharingRegistry")
                      .child(superAdminID)
                      .once("value")
                      .then(async (snapshot) => {
                        const snapshotData = snapshot.val();
                        let duplicateFound = false;
                        let recipientEmails = [];
                        let recipientUIDs = [];
                        if (snapshotData && typeof snapshotData === "object") {
                          for (const key of Object.keys(snapshotData)) {
                            const registryData = snapshotData[key];

                            const daysMatch =
                              recurringDays.length === 0 &&
                              registryData.recurringDays === undefined
                                ? true
                                : recurringDays.length === 0 &&
                                  registryData.recurringDays !== undefined
                                ? false
                                : recurringDays.length > 0 &&
                                  registryData.recurringDays === undefined
                                ? false
                                : JSON.stringify(recurringDays) ===
                                  JSON.stringify(registryData.recurringDays);

                            const dailyTimesMatch =
                              recurringDailyAccess.TimedAccess === false &&
                              registryData.selectedRecurringTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime ===
                                    undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime
                                    .startTime === undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === false &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? true
                                  : false
                                : recurringDailyAccess.TimedAccess === true &&
                                  registryData.selectedRecurringTime !==
                                    undefined
                                ? registryData.selectedRecurringTime
                                    .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.selectedTime
                                      .startTime ===
                                      registryData.selectedRecurringTime
                                        .startTime &&
                                    recurringDailyAccess.selectedTime
                                      .endTime ===
                                      registryData.selectedRecurringTime.endTime
                                : false;

                            if (
                              selectedLock.ip45SerialNumber ==
                                registryData.lockSerial &&
                              recipient.userEmail ==
                                registryData.sharedToEmail &&
                              sharingMode == registryData.sharingMode &&
                              registryData.shareStartTime == 0 &&
                              registryData.shareEndTime == 0 &&
                              daysMatch &&
                              dailyTimesMatch
                            ) {
                              duplicateFound = true;
                              duplicateUsers.push(recipient.userEmail);
                              // console.log(
                              //   "=================================================="
                              // );
                              // console.log(
                              //   "Duplicate found in retractableSharingRegistry"
                              // );
                              // console.log(
                              //   "Lock Serial [ SM: " +
                              //     selectedLock.ip45SerialNumber +
                              //     " = DB: " +
                              //     registryData.lockSerial +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recipient [ SM: " +
                              //     recipient.userEmail +
                              //     " = DB: " +
                              //     registryData.sharedToEmail +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Sharing Mode [ SM: " +
                              //     sharingMode +
                              //     " = DB: " +
                              //     registryData.sharingMode +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Start Time [ SM: 0 = DB: " +
                              //     registryData.shareStartTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "End Time [ SM: 0 = DB: " +
                              //     registryData.shareEndTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recurring Days [ SM: " +
                              //     JSON.stringify(recurringDays) +
                              //     " = DB: " +
                              //     (registryData.recurringDays == undefined
                              //       ? "[]"
                              //       : JSON.stringify(
                              //           registryData.recurringDays
                              //         )) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily Start Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.startTime +
                              //     " = DB: " +
                              //     (registryData.selectedRecurringTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .startTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .startTime) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily End Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.endTime +
                              //     " = DB: " +
                              //     (registryData.selectedRecurringTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .endTime == undefined
                              //       ? "null"
                              //       : registryData.selectedRecurringTime
                              //           .endTime) +
                              //     " ]"
                              // );
                            } else {
                              if (
                                !recipientEmails.includes(recipient.userEmail)
                              ) {
                                recipientEmails.push(recipient.userEmail);
                              }
                            }
                          }
                        } else {
                          console.error("snapshotData is null or undefined");
                        }

                        // If no duplicate found in retractableSharingRegistry, check userLocks
                        if (!duplicateFound && recipientEmails.length > 0) {
                          return Promise.all(
                            recipientEmails.map((recipientEmail) => {
                              return fire
                                .database()
                                .ref("registeredUsersOnPlatform")
                                .orderByValue()
                                .equalTo(recipientEmail)
                                .once("value")
                                .then((snapshot) => {
                                  if (snapshot.exists()) {
                                    snapshot.forEach((eachSnapshot) => {
                                      const recipientUID = eachSnapshot.key;
                                      recipientUIDs.push(recipientUID);
                                    });
                                  }
                                });
                            })
                          ).then(() => {
                            return Promise.all(
                              recipientUIDs.map((recipientUID) => {
                                return fire
                                  .database()
                                  .ref("userLocks")
                                  .child(recipientUID)
                                  .once("value")
                                  .then(async (snapshot) => {
                                    const snapshotData = snapshot.val();

                                    if (snapshotData != undefined) {
                                      for (const key of Object.keys(
                                        snapshotData
                                      )) {
                                        const userLocksData = snapshotData[key];

                                        const daysMatch =
                                          recurringDays.length === 0 &&
                                          userLocksData.recurringDays ===
                                            undefined
                                            ? true
                                            : recurringDays.length === 0 &&
                                              userLocksData.recurringDays !==
                                                undefined
                                            ? false
                                            : recurringDays.length > 0 &&
                                              userLocksData.recurringDays ===
                                                undefined
                                            ? false
                                            : JSON.stringify(recurringDays) ===
                                              JSON.stringify(
                                                userLocksData.recurringDays
                                              );

                                        const dailyTimesMatch =
                                          recurringDailyAccess.TimedAccess ===
                                            false &&
                                          userLocksData.selectedRecurringTime ===
                                            undefined
                                            ? true
                                            : recurringDailyAccess.TimedAccess ===
                                                false &&
                                              userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                            ? true
                                            : recurringDailyAccess.TimedAccess ===
                                                true &&
                                              userLocksData.selectedRecurringTime ===
                                                undefined
                                            ? false
                                            : recurringDailyAccess.TimedAccess ===
                                                true &&
                                              userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                            ? false
                                            : recurringDailyAccess.TimedAccess ===
                                                false &&
                                              userLocksData.selectedRecurringTime !==
                                                undefined
                                            ? userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                              ? true
                                              : false
                                            : recurringDailyAccess.TimedAccess ===
                                                true &&
                                              userLocksData.selectedRecurringTime !==
                                                undefined
                                            ? userLocksData
                                                .selectedRecurringTime
                                                .startTime === undefined
                                              ? false
                                              : recurringDailyAccess
                                                  .selectedTime.startTime ===
                                                  userLocksData
                                                    .selectedRecurringTime
                                                    .startTime &&
                                                recurringDailyAccess
                                                  .selectedTime.endTime ===
                                                  userLocksData
                                                    .selectedRecurringTime
                                                    .endTime
                                            : false;

                                        if (
                                          selectedLock.ip45SerialNumber ==
                                            userLocksData.ip45SerialNumber &&
                                          sharingMode ==
                                            userLocksData.sharingMode &&
                                          userLocksData.shareStartTime == 0 &&
                                          userLocksData.shareEndTime == 0 &&
                                          daysMatch &&
                                          dailyTimesMatch
                                        ) {
                                          duplicateUsers.push(
                                            recipient.userEmail
                                          );
                                          // console.log(
                                          //   "=================================================="
                                          // );
                                          // console.log(
                                          //   "Duplicate found in userLocks"
                                          // );
                                          // console.log(
                                          //   "Lock Serial [ SM: " +
                                          //     selectedLock.ip45SerialNumber +
                                          //     " = DB: " +
                                          //     userLocksData.ip45SerialNumber +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Recipient [ SM: " +
                                          //     recipient.userEmail +
                                          //     " = DB: " +
                                          //     recipient.userEmail +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Sharing Mode [ SM: " +
                                          //     sharingMode +
                                          //     " = DB: " +
                                          //     userLocksData.sharingMode +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Start Time [ SM: 0 = DB: " +
                                          //     userLocksData.shareStartTime +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "End Time [ SM: 0 = DB: " +
                                          //     userLocksData.shareEndTime +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Recurring Days [ SM: " +
                                          //     JSON.stringify(recurringDays) +
                                          //     " = DB: " +
                                          //     (userLocksData.recurringDays ==
                                          //     undefined
                                          //       ? "[]"
                                          //       : JSON.stringify(
                                          //           userLocksData.recurringDays
                                          //         )) +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Daily Start Time [ SM: " +
                                          //     recurringDailyAccess.selectedTime
                                          //       .startTime +
                                          //     " = DB: " +
                                          //     (userLocksData.selectedRecurringTime ==
                                          //     undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .startTime == undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .startTime) +
                                          //     " ]"
                                          // );
                                          // console.log(
                                          //   "Daily End Time [ SM: " +
                                          //     recurringDailyAccess.selectedTime
                                          //       .endTime +
                                          //     " = DB: " +
                                          //     (userLocksData.selectedRecurringTime ==
                                          //     undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .endTime == undefined
                                          //       ? "null"
                                          //       : userLocksData
                                          //           .selectedRecurringTime
                                          //           .endTime) +
                                          //     " ]"
                                          // );
                                        }
                                      }
                                    }
                                  });
                              })
                            );
                          });
                        }
                      });
                  });

                  Promise.all(promises).then(() => {
                    // If no duplicates are found in both retractableSharingRegistry and userLocks for all selected recipients, proceed to grant access
                    if (duplicateUsers.length < 1) {
                      // console.log("No duplicates found");
                      grantUserAccess(
                        selectedRecipients,
                        selectedGroups,
                        selectedLockgroup,
                        AlllockGroupArray,
                        selectedLock,
                        selectedDays,
                        0,
                        0,
                        retractMode,
                        OTAMode,
                        recurringMode,
                        recurringDailyAccess,
                        selectedAdmins,
                        showAdminLists,
                        superAdminID,
                        sharePermissionType,
                        this.state.timechecked,
                        this.state.currentLanguage,
                        (callback) => {
                          if (callback.done) {
                            // console.log("callback?" + callback);
                            const userWithoutApp = callback.userWithoutApp;
                            if (
                              userWithoutApp.length !==
                              selectedRecipients.length
                            ) {
                              this.showSharedNotification();
                            }
                            userWithoutApp.forEach((eachUser) => {
                              this.showNotification(
                                `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                                "error",
                                5
                              );
                            });
                            this.setState({ processing: false });
                            this.clearForm();
                          }
                        }
                      );
                    } else {
                      // console.log(
                      //   "=================================================="
                      // );
                      for (let i = 0; i < duplicateUsers.length; i++) {
                        // console.log(
                        //   "Identical shared access found for " +
                        //     duplicateUsers[i]
                        // );
                        this.showNotification(
                          `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                          "error",
                          5
                        );
                      }
                      this.setState({ processing: false });
                      this.clearForm();
                    }
                  });
                }
              }
            }
          }
        }
      }
      // } else if (showAdminLists && selectedAdmins.length <= 0) {
      //   this.showNotification(localizationStrings.selectAdmin, "error", 5);
    } else if (this.state.radioGrouplockChecked) {
      //this is lock group sharing
      // console.log("Grant ID: 18");

      // this.showNotification(
      //   `${localizationStrings.waitMessage}`,
      //   "warning",
      //   2
      // );

      let sharingMode = "";
      let recurringDays = [];
      let duplicateUsers = [];
      let isGroup = false;

      if (selectedGroups.length > 0) {
        // console.log("Grant ID: 18 is group true");
        isGroup = true;
      }

      if (recurringMode) {
        // console.log("Grant ID: 18 is recurring true");

        if (OTAMode && !showAdminLists) {
          isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
        } else if (!OTAMode && showAdminLists) {
          isGroup ? (sharingMode = "MULTI-GRP") : (sharingMode = "MULTI");
        } else if (OTAMode && showAdminLists) {
          isGroup
            ? (sharingMode = "MULTI-OTA-GRP")
            : (sharingMode = "MULTI-OTA");
        } else if (recurringDailyAccess.TimedAccess) {
          isGroup
            ? (sharingMode = "NORMAL-RECURR-TIMED-GRP")
            : (sharingMode = "NORMAL-RECURR-TIMED");
        } else {
          isGroup
            ? (sharingMode = "NORMAL-RECURR-GRP")
            : (sharingMode = "NORMAL-RECURR");
        }

        if (selectedDays.sunday === true) {
          recurringDays.push(0);
        }
        if (selectedDays.monday === true) {
          recurringDays.push(1);
        }
        if (selectedDays.tuesday === true) {
          recurringDays.push(2);
        }
        if (selectedDays.wednesday === true) {
          recurringDays.push(3);
        }
        if (selectedDays.thursday === true) {
          recurringDays.push(4);
        }
        if (selectedDays.friday === true) {
          recurringDays.push(5);
        }
        if (selectedDays.saturday === true) {
          recurringDays.push(6);
        }
      } else {
        // console.log("Grant ID: 18 not recurring");

        if (OTAMode && !showAdminLists) {
          isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
          // console.log("Grant ID: 18 ota " + sharingMode);
        } else if (!OTAMode && showAdminLists) {
          isGroup ? (sharingMode = "MULTI-GRP") : (sharingMode = "MULTI");
          // console.log("Grant ID: 18 multi " + sharingMode);
        } else if (OTAMode && showAdminLists) {
          isGroup
            ? (sharingMode = "MULTI-OTA-GRP")
            : (sharingMode = "MULTI-OTA");
          // console.log("Grant ID: 18 ota multi " + sharingMode);
        } else {
          isGroup ? (sharingMode = "NORMAL-GRP") : (sharingMode = "NORMAL");
          // console.log("Grant ID: 18 sharing normal " + sharingMode);
        }
      }

      if (isGroup) {
        // console.log("Grant ID: 18 is group "+isGroup);
        // Check for duplicates in lockGroupManagement
        fire
          .database()
          .ref("lockGroupManagement")
          .child(superAdminID)
          .child(auth.currentUser.uid)
          .once("value")
          .then(async (snapshot) => {
            const snapshotData = snapshot.val();
            for (const childSnapshotKey in snapshotData) {
              const lockGroupData = snapshotData[childSnapshotKey];
              const lockGroupName = lockGroupData.name;

              if (selectedLockgroup === lockGroupName) {
                const promises = selectedGroups.map((group) => {
                  return fire
                    .database()
                    .ref("lockGroupManagement")
                    .child(superAdminID)
                    .child(auth.currentUser.uid)
                    .child(childSnapshotKey)
                    .child("sharedInstances")
                    .once("value")
                    .then(async (snapshot) => {
                      const snapshotData = snapshot.val();

                      if (snapshotData != undefined) {
                        if (snapshotData && typeof snapshotData === "object") {
                          for (const key of Object.keys(snapshotData)) {
                            const sharedInstancesData = snapshotData[key];

                            const daysMatch =
                              recurringDays.length === 0 &&
                              sharedInstancesData.recurringDays === undefined
                                ? true
                                : recurringDays.length === 0 &&
                                  sharedInstancesData.recurringDays !==
                                    undefined
                                ? false
                                : recurringDays.length > 0 &&
                                  sharedInstancesData.recurringDays ===
                                    undefined
                                ? false
                                : JSON.stringify(recurringDays) ===
                                  JSON.stringify(
                                    sharedInstancesData.recurringDays
                                  );

                            const dailyTimesMatch =
                              recurringDailyAccess.TimedAccess === false &&
                              sharedInstancesData.selectedRecurringTime ===
                                undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === false &&
                                  sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === true &&
                                  sharedInstancesData.selectedRecurringTime ===
                                    undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === true &&
                                  sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === false &&
                                  sharedInstancesData.selectedRecurringTime !==
                                    undefined
                                ? sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                  ? true
                                  : false
                                : recurringDailyAccess.TimedAccess === true &&
                                  sharedInstancesData.selectedRecurringTime !==
                                    undefined
                                ? sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.selectedTime
                                      .startTime ===
                                      sharedInstancesData.selectedRecurringTime
                                        .startTime &&
                                    recurringDailyAccess.selectedTime
                                      .endTime ===
                                      sharedInstancesData.selectedRecurringTime
                                        .endTime
                                : false;

                            if (
                              sharedInstancesData.recipientType == "GROUP" &&
                              group.groupName ==
                                sharedInstancesData.recipient &&
                              sharingMode == sharedInstancesData.sharingMode &&
                              (this.state.timechecked &&
                              selectedStartDate !== selectedEndDate
                                ? selectedStartDate ==
                                  sharedInstancesData.shareStartTime
                                : sharedInstancesData.shareStartTime == 0) &&
                              (this.state.timechecked &&
                              selectedEndDate !== selectedStartDate
                                ? selectedEndDate ==
                                  sharedInstancesData.shareEndTime
                                : sharedInstancesData.shareEndTime == 0) &&
                              daysMatch &&
                              dailyTimesMatch
                            ) {
                              duplicateUsers.push(group.groupName);
                              // console.log(
                              //   "=================================================="
                              // );
                              // console.log(
                              //   "Duplicate found in lockGroupManagement"
                              // );
                              // console.log(
                              //   "Lock Group [ SM: " +
                              //     selectedLockgroup +
                              //     " = DB: " +
                              //     lockGroupName +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recipient [ SM: " +
                              //     group.groupName +
                              //     " = DB: " +
                              //     sharedInstancesData.recipient +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Sharing Mode [ SM: " +
                              //     sharingMode +
                              //     " = DB: " +
                              //     sharedInstancesData.sharingMode +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Start Time [ SM: " +
                              //     (this.state.timechecked &&
                              //     selectedStartDate !== selectedEndDate
                              //       ? selectedStartDate
                              //       : "0") +
                              //     " = DB: " +
                              //     sharedInstancesData.shareStartTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "End Time [ SM: " +
                              //     (this.state.timechecked &&
                              //     selectedEndDate !== selectedStartDate
                              //       ? selectedEndDate
                              //       : "0") +
                              //     " = DB: " +
                              //     sharedInstancesData.shareEndTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recurring Days [ SM: " +
                              //     JSON.stringify(recurringDays) +
                              //     " = DB: " +
                              //     (sharedInstancesData.recurringDays == undefined
                              //       ? "[]"
                              //       : JSON.stringify(
                              //           sharedInstancesData.recurringDays
                              //         )) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily Start Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.startTime +
                              //     " = DB: " +
                              //     (sharedInstancesData.selectedRecurringTime ==
                              //     undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .startTime == undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .startTime) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily End Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.endTime +
                              //     " = DB: " +
                              //     (sharedInstancesData.selectedRecurringTime ==
                              //     undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .endTime == undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .endTime) +
                              //     " ]"
                              // );
                            }
                          }
                        } else {
                          console.error("snapshotData is null or undefined");
                        }
                      }
                    });
                });

                Promise.all(promises).then(() => {
                  // If no duplicates are found in lockGroupManagement for all selected groups, proceed to grant access
                  if (duplicateUsers.length < 1) {
                    // console.log("No duplicates found");
                    // console.log("Grant ID: 18 No duplicates found 1");

                    grantUserLockGroupAccess(
                      selectedRecipients,
                      selectedGroups,
                      selectedLockgroup,
                      AlllockGroupArray,
                      selectedLock,
                      selectedDays,
                      this.state.timechecked &&
                        selectedStartDate !== selectedEndDate
                        ? selectedStartDate
                        : 0,
                      this.state.timechecked &&
                        selectedEndDate !== selectedStartDate
                        ? selectedEndDate
                        : 0,
                      retractMode,
                      OTAMode,
                      recurringMode,
                      recurringDailyAccess,
                      selectedAdmins,
                      showAdminLists,
                      superAdminID,
                      sharePermissionType,
                      this.state.timechecked,
                      this.state.currentLanguage,
                      (callback) => {
                        if (callback.done) {
                          // console.log("callback?" + callback);
                          const userWithoutApp = callback.userWithoutApp;
                          if (
                            userWithoutApp.length !== selectedRecipients.length
                          ) {
                            this.showSharedNotification();
                          }
                          userWithoutApp.forEach((eachUser) => {
                            this.showNotification(
                              `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                              "error",
                              5
                            );
                          });
                          this.setState({ processing: false });
                          this.clearForm();
                        }
                      }
                    );
                  } else {
                    // console.log(
                    //   "=================================================="
                    // );
                    for (let i = 0; i < duplicateUsers.length; i++) {
                      // console.log(
                      //   "Identical shared access found for " + duplicateUsers[i]
                      // );
                      this.showNotification(
                        `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                        "error",
                        5
                      );
                    }
                    this.setState({ processing: false });
                    this.clearForm();
                  }
                });
              }
            }
          });
      } else {
        // Check for duplicates in lockGroupManagement
        fire
          .database()
          .ref("lockGroupManagement")
          .child(superAdminID)
          .child(auth.currentUser.uid)
          .once("value")
          .then(async (snapshot) => {
            const snapshotData = snapshot.val();
            for (const childSnapshotKey in snapshotData) {
              const lockGroupData = snapshotData[childSnapshotKey];
              const lockGroupName = lockGroupData.name;

              if (selectedLockgroup === lockGroupName) {
                const promises = selectedRecipients.map((recipient) => {
                  return fire
                    .database()
                    .ref("lockGroupManagement")
                    .child(superAdminID)
                    .child(auth.currentUser.uid)
                    .child(childSnapshotKey)
                    .child("sharedInstances")
                    .once("value")
                    .then(async (snapshot) => {
                      const snapshotData = snapshot.val();

                      if (snapshotData != undefined) {
                        if (snapshotData && typeof snapshotData === "object") {
                          for (const key of Object.keys(snapshotData)) {
                            const sharedInstancesData = snapshotData[key];

                            const daysMatch =
                              recurringDays.length === 0 &&
                              sharedInstancesData.recurringDays === undefined
                                ? true
                                : recurringDays.length === 0 &&
                                  sharedInstancesData.recurringDays !==
                                    undefined
                                ? false
                                : recurringDays.length > 0 &&
                                  sharedInstancesData.recurringDays ===
                                    undefined
                                ? false
                                : JSON.stringify(recurringDays) ===
                                  JSON.stringify(
                                    sharedInstancesData.recurringDays
                                  );

                            const dailyTimesMatch =
                              recurringDailyAccess.TimedAccess === false &&
                              sharedInstancesData.selectedRecurringTime ===
                                undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === false &&
                                  sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                ? true
                                : recurringDailyAccess.TimedAccess === true &&
                                  sharedInstancesData.selectedRecurringTime ===
                                    undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === true &&
                                  sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                ? false
                                : recurringDailyAccess.TimedAccess === false &&
                                  sharedInstancesData.selectedRecurringTime !==
                                    undefined
                                ? sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                  ? true
                                  : false
                                : recurringDailyAccess.TimedAccess === true &&
                                  sharedInstancesData.selectedRecurringTime !==
                                    undefined
                                ? sharedInstancesData.selectedRecurringTime
                                    .startTime === undefined
                                  ? false
                                  : recurringDailyAccess.selectedTime
                                      .startTime ===
                                      sharedInstancesData.selectedRecurringTime
                                        .startTime &&
                                    recurringDailyAccess.selectedTime
                                      .endTime ===
                                      sharedInstancesData.selectedRecurringTime
                                        .endTime
                                : false;

                            if (
                              sharedInstancesData.recipientType ==
                                "INDIVIDUAL" &&
                              recipient.userEmail ==
                                sharedInstancesData.recipient &&
                              sharingMode == sharedInstancesData.sharingMode &&
                              (this.state.timechecked &&
                              selectedStartDate !== selectedEndDate
                                ? selectedStartDate ==
                                  sharedInstancesData.shareStartTime
                                : sharedInstancesData.shareStartTime == 0) &&
                              (this.state.timechecked &&
                              selectedEndDate !== selectedStartDate
                                ? selectedEndDate ==
                                  sharedInstancesData.shareEndTime
                                : sharedInstancesData.shareEndTime == 0) &&
                              daysMatch &&
                              dailyTimesMatch
                            ) {
                              duplicateUsers.push(recipient.userEmail);
                              // console.log(
                              //   "=================================================="
                              // );
                              // console.log(
                              //   "Duplicate found in lockGroupManagement"
                              // );
                              // console.log(
                              //   "Lock Group [ SM: " +
                              //     selectedLockgroup +
                              //     " = DB: " +
                              //     lockGroupName +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recipient [ SM: " +
                              //     recipient.userEmail +
                              //     " = DB: " +
                              //     sharedInstancesData.recipient +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Sharing Mode [ SM: " +
                              //     sharingMode +
                              //     " = DB: " +
                              //     sharedInstancesData.sharingMode +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Start Time [ SM: " +
                              //     (this.state.timechecked &&
                              //     selectedStartDate !== selectedEndDate
                              //       ? selectedStartDate
                              //       : "0") +
                              //     " = DB: " +
                              //     sharedInstancesData.shareStartTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "End Time [ SM: " +
                              //     (this.state.timechecked &&
                              //     selectedEndDate !== selectedStartDate
                              //       ? selectedEndDate
                              //       : "0") +
                              //     " = DB: " +
                              //     sharedInstancesData.shareEndTime +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Recurring Days [ SM: " +
                              //     JSON.stringify(recurringDays) +
                              //     " = DB: " +
                              //     (sharedInstancesData.recurringDays == undefined
                              //       ? "[]"
                              //       : JSON.stringify(
                              //           sharedInstancesData.recurringDays
                              //         )) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily Start Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.startTime +
                              //     " = DB: " +
                              //     (sharedInstancesData.selectedRecurringTime ==
                              //     undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .startTime == undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .startTime) +
                              //     " ]"
                              // );
                              // console.log(
                              //   "Daily End Time [ SM: " +
                              //     recurringDailyAccess.selectedTime.endTime +
                              //     " = DB: " +
                              //     (sharedInstancesData.selectedRecurringTime ==
                              //     undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .endTime == undefined
                              //       ? "null"
                              //       : sharedInstancesData.selectedRecurringTime
                              //           .endTime) +
                              //     " ]"
                              // );
                            }
                          }
                        } else {
                          console.error("snapshotData is null or undefined");
                        }
                      }
                    });
                });

                Promise.all(promises).then(() => {
                  // If no duplicates are found in lockGroupManagement for all selected recipients, proceed to grant access
                  if (duplicateUsers.length < 1) {
                    // console.log("No duplicates found");
                    // console.log("Grant ID: 18 No duplicates found 2");

                    grantUserLockGroupAccess(
                      selectedRecipients,
                      selectedGroups,
                      selectedLockgroup,
                      AlllockGroupArray,
                      selectedLock,
                      selectedDays,
                      this.state.timechecked &&
                        selectedStartDate !== selectedEndDate
                        ? selectedStartDate
                        : 0,
                      this.state.timechecked &&
                        selectedEndDate !== selectedStartDate
                        ? selectedEndDate
                        : 0,
                      retractMode,
                      OTAMode,
                      recurringMode,
                      recurringDailyAccess,
                      selectedAdmins,
                      showAdminLists,
                      superAdminID,
                      sharePermissionType,
                      this.state.timechecked,
                      this.state.currentLanguage,
                      (callback) => {
                        if (callback.done) {
                          // console.log("callback?" + callback);
                          const userWithoutApp = callback.userWithoutApp;
                          if (
                            userWithoutApp.length !== selectedRecipients.length
                          ) {
                            this.showSharedNotification();
                          }
                          userWithoutApp.forEach((eachUser) => {
                            this.showNotification(
                              `${localizationStrings.userWOApp1} ${eachUser.userEmail} ${localizationStrings.userWOApp2}`,
                              "error",
                              5
                            );
                          });
                          this.setState({ processing: false });
                          this.clearForm();
                        }
                      }
                    );
                  } else {
                    // console.log(
                    //   "=================================================="
                    // );
                    for (let i = 0; i < duplicateUsers.length; i++) {
                      // console.log(
                      //   "Identical shared access found for " + duplicateUsers[i]
                      // );
                      this.showNotification(
                        `${duplicateUsers[i]} already has an identical shared access to the lock.`,
                        "error",
                        5
                      );
                    }
                    this.setState({ processing: false });
                    this.clearForm();
                  }
                });
              }
            }
          });
      }
    } else {
      //! selectedLock === undefined
      //! selectedRecipients.length <= 0
      // if (this.state.radioGroupChecked) {
      //   this.showNotification(localizationStrings.emptyFieldGroup, "error", 5);
      // } else {
      //   this.showNotification(localizationStrings.emptyField, "error", 5);
      // }

      if (showAdminLists && selectedAdmins.length <= 0) {
        this.showNotification(localizationStrings.selectAdmin, "error", 5);
        this.setState({ processing: false });
      } else if (this.state.radioGroupChecked) {
        this.showNotification(localizationStrings.emptyFieldGroup, "error", 5);
        this.setState({ processing: false });
      } else if (this.state.radioIndividualChecked) {
        this.showNotification(localizationStrings.emptyField, "error", 5);
        this.setState({ processing: false });
      }
    }
  } //end

  handlePopupOpen() {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.shareLockGuide,
      popupImage: [<ShareLock />],
    });
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  handleRadioIndividual() {
    this.setState({
      radioIndividualChecked: true,
      radioGroupChecked: false,
      selectedGroups: [],
      selectedRecipients: [],
      showTable: false,
      // subtractAdminArray: this.state.adminDetails,
      // selectedAdmins: [],
      checkboxChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
      //monday - sunday set all false
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,
    });
  }

  handleRadioGroup() {
    this.setState({
      radioIndividualChecked: false,
      radioGroupChecked: true,
      selectedGroups: [],
      selectedRecipients: [],
      showTable: false,
      // subtractAdminArray: this.state.adminDetails,
      // selectedAdmins: [],
      checkboxChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
      //monday - sunday set all false
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      // Set to default values when disabling One Time Access Switch for Group Sharing
      OTAMode: false,
      disabledState: false,
    });
  }

  handleRadioNormal() {
    this.setState({
      timechecked: false,

      recurringStartText: localizationStrings.startTimeTitle,
      recurringEndText: localizationStrings.endTimeTitle,

      startTime: null,
      endTime: null,

      recurringFullDay: true,
      recurringTimed: false,

      //monday - sunday set all false
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
    });
  }

  handleRadioRecurring() {
    this.setState({
      timechecked: true,

      OTAMode: false,
      showAdminLists: false,

      radioNormalChecked: false,
      radioRecurringChecked: true,
    });
  }

  radioIndividualLock() {
    //handle
    this.setState({
      selectedLockgroup: null,

      radioGrouplockChecked: false,
      radioIndividualLockChecked: true,

      selectedGroups: [],
      selectedRecipients: [],
      showTable: false,
      checkboxChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      OTAMode: false,
      disabledState: false,
    });
  }
  radioGrouplock() {
    //handle
    this.setState({
      selectedLock: null,

      radioIndividualLockChecked: false,
      radioGrouplockChecked: true,

      selectedGroups: [],
      selectedRecipients: [],
      showTable: false,
      checkboxChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      OTAMode: false,
      disabledState: false,
    });
  }

  handleTabs(key) {
    if (key === 0) {
      this.setState({
        endDate: new Date(new Date().setMinutes(0, 0, 0)),
        startDate: new Date(new Date().setMinutes(0, 0, 0)),
        calendarStartText: "Select your start time",
        calendarEndText: "Select your end time",
        selectedLock: null,
        radioIndividualChecked: true,
        radioGroupChecked: false,
        radioIndividualLockChecked: true,
        radioGrouplockChecked: false,
        selectedRecipients: [],
        selectedGroups: [],
        showTable: false,
        selectedAdmins: [],
        showAdminLists: false,
        subtractAdminArray: [],
        subtractRecipientArray: [],
        checkboxChecked: false,
        isSharedLock: false,

        // Reset Switch Buttons
        timechecked: false,
        isRetractMode: true,
        OTAMode: false,
        disabledState: false, //for OTA & Sharing Mode
        disabledStateMultiShare: false, //for Multishare & Sharing Mode
        disabledStateShareLock: false, //for OnlineSharedLock & Sharing Mode
      });
    }
  }

  handleCheck(event) {
    // console.log(event.target.checked);
    this.setState({
      checkboxChecked: event.target.checked,

      // Set to default values when disabling One Time Access Switch
      OTAMode: false,
      disabledState: false,

      // Set to default values when disabling Multi Approve Switch
      showAdminLists: false,
      disabledStateMultiShare: false,
      selectedAdmins: [],
    });
  }

  handleRecurringCheck(event) {
    if (event.target.name === "recurringCheckMon") {
      this.setState({ recurringCheckMon: event.target.checked });
    } else if (event.target.name === "recurringCheckTue") {
      this.setState({ recurringCheckTue: event.target.checked });
    } else if (event.target.name === "recurringCheckWed") {
      this.setState({ recurringCheckWed: event.target.checked });
    } else if (event.target.name === "recurringCheckThu") {
      this.setState({ recurringCheckThu: event.target.checked });
    } else if (event.target.name === "recurringCheckFri") {
      this.setState({ recurringCheckFri: event.target.checked });
    } else if (event.target.name === "recurringCheckSat") {
      this.setState({ recurringCheckSat: event.target.checked });
    } else if (event.target.name === "recurringCheckSun") {
      this.setState({ recurringCheckSun: event.target.checked });
    }
  }

  convertStartTime(startTime) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(startTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(startTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(startTime * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(startTime * 1000);

      return japanDate + " " + japanTime;
    } else {
      const start = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit"
      }).format(startTime * 1000);

      return start;
    }
  }

  convertEndTime(endTime) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(endTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(endTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(endTime * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(endTime * 1000);

      return japanDate + " " + japanTime;
    } else {
      const end = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit"
      }).format(endTime * 1000);

      return end;
    }
  }

  updateRecipientChanges = (data) => {
    this.handleFriendsArray(data);
  };

  updateGroupChanges = (data) => {
    this.handleGroupsArray(data);
  };

  updateAdminChanges = (data) => {
    this.handleChangeMultiSharing(data);
  };

  handleSwitchChange = (updatedSwitchValue) => {
    this.setState({ isDisabledSwitch: updatedSwitchValue });
  };

  onCheckboxChange4 = (updatedValue) => {
    this.setState({ checkboxChecked5: updatedValue });
  };

  onCheckboxChange5 = (updatedValue) => {
    this.setState({ checkboxChecked6: updatedValue });
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { isDisabledSwitch } = this.state;

    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div style={{ maxWidth: "95%", margin: "auto" }}>
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="header">
          <div className="helpDiv">
            <h2 id="test">{localizationStrings.grantAccessTitle}</h2>
            <button className="helpBtn" onClick={this.handlePopupOpen}>
              <p className="fa fa-question-circle" />

              <p style={{ fontSize: "24px" }}>Help</p>
            </button>
          </div>
        </div>
        <br />
        <Tabs defaultIndex={0} onSelect={this.handleTabs}>
          <TabList>
            <Tab>{localizationStrings.lockSharingTab}</Tab>
            <Tab>{localizationStrings.shareHistoryTab}</Tab>
            {/* <Tab>{localizationStrings.lockSchedulingTab}</Tab> */}
          </TabList>

          <TabPanel>
            <br />
            <br />
            {this.state.initialLoading && (
              <div style={{ textAlign: "center", marginTop: "80px" }}>
                <Loading />
              </div>
            )}
            {!this.state.initialLoading && (
              <div
                style={{
                  maxWidth: "80%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  position: "relative",
                }}
              >
                {this.state.processing && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      background: "rgba(255, 255, 255, 0.65)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                      pointerEvents: "none",
                    }}
                  >
                    <Loading />
                    <div style={{ marginTop: "12px", fontWeight: "bold" }}>
                      {localizationStrings.waitMessage}
                    </div>
                  </div>
                )}
                <form id="grantAccessForm" onSubmit={this.handlewindowShow}>
                  <FormGroup>
                    <div
                      className={"displayBlock"}
                      // style={{ display: "flex" }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1.8em",
                            fontWeight: "bolder",
                          }}
                        >
                          {localizationStrings.step1Message}
                        </h5>
                        <br></br>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                marginTop: this.state.radioIndividualLockChecked
                                  ? this.state.noShareableLocks
                                    ? "-14px"
                                    : "0"
                                  : this.state.noShareableLockGroups
                                  ? "0"
                                  : "0px",
                              }}
                            >
                              <Radio
                                className="grantAccessRadioBtn"
                                style={{
                                  fontSize: "1.3em",
                                  fontWeight: "bold",
                                }}
                                name="Groupbutton"
                                inline
                                checked={this.state.radioIndividualLockChecked}
                                onClick={this.radioIndividualLock} //change
                                readOnly
                              >
                                &nbsp;
                                {localizationStrings.selectLockTitleindividual}
                              </Radio>
                              <Radio
                                className="grantAccessRadioBtn"
                                style={{
                                  fontSize: "1.3em",
                                  fontWeight: "bold",
                                  marginLeft: "30px",
                                  display:
                                    this.state.isSuperAdmin
                                      ? "inline-block"
                                      : "none",
                                }}
                                name="Groupbutton"
                                inline
                                checked={this.state.radioGrouplockChecked} //change
                                onClick={this.radioGrouplock}
                                readOnly
                              >
                                &nbsp;
                                {localizationStrings.selectLockTitleGroup}
                              </Radio>
                            </div>

                            {/* {this.state.noShareableLocks &&
                              this.state.radioIndividualLockChecked &&
                              this.state.isDisabledSwitch &&
                              !this.state.checkboxChecked5 &&
                              !this.state.checkboxChecked6 && (
                                <div style={{ margin: "30px 0 -8px 25px" }}>
                                  <p
                                    style={{ fontSize: "16px", color: "grey" }}
                                  >
                                    {localizationStrings.noLocks}
                                  </p>
                                </div>
                              )} */}

                            {/* {this.state.noShareableLockGroups &&
                              this.state.radioGrouplockChecked && (
                                <div style={{ margin: "30px 0 -15px 25px" }}>
                                  <p
                                    style={{ fontSize: "16px", color: "grey" }}
                                  >
                                    {localizationStrings.noLockGroups}
                                  </p>
                                </div>
                              )} */}

                            <div
                              className={"displayBlock"}
                              style={{
                                display: this.state.radioIndividualLockChecked
                                  ? "block"
                                  : "none",
                              }}
                            >
                              <br />
                              <br />
                              <Select
                                value={
                                  this.state.selectedLock
                                    ? {
                                        label: this.state.selectedLock.Name,
                                        value: this.state.selectedLock.Id,
                                      }
                                    : null
                                }
                                onChange={this.detectOnLockDropdownChangeEvent}
                                options={this.renderDropdown()}
                                placeholder={
                                  localizationStrings.selectLockTitle
                                }
                                aria-label={localizationStrings.selectLockTitle}
                                formatOptionLabel={({ label }) => label}
                                isClearable={true}
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    outline: "none",
                                    boxShadow: state.isFocused
                                      ? "none"
                                      : provided.boxShadow,
                                    borderColor: state.isFocused
                                      ? "black"
                                      : provided.borderColor,
                                    width: "100%",
                                    backgroundColor: "white",
                                    color: "black",
                                    fontWeight: "bold",
                                    border: "4px solid #3c3e41",
                                    borderRadius: "12px",
                                    "&:hover": {
                                      borderColor: "black",
                                      cursor: "pointer",
                                    },
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    fontWeight: "bold",
                                  }),
                                  placeholder: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    fontWeight: "bold",
                                  }),
                                  indicatorsContainer: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  dropdownIndicator: (provided, state) => ({
                                    ...provided,
                                    color: "black",
                                    "&:hover": {
                                      color: "black",
                                    },
                                  }),
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    backgroundColor: "black",
                                  }),
                                  clearIndicator: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    "&:hover": {
                                      color: "black",
                                    },
                                  }),
                                }}
                              />
                            </div>

                            {this.state.isSharedLock &&
                            this.state.selectedLock ? (
                              this.state.selectedLock.shareStartTime > 0 &&
                              this.state.selectedLock.shareEndTime > 0 ? (
                                <p
                                  style={{
                                    color: "red",
                                    fontSize: "1.3em",
                                    marginTop: "20px",
                                  }}
                                >
                                  {localizationStrings.timedAccessLock1}{" "}
                                  {this.convertStartTime(
                                    this.state.selectedLock.shareStartTime
                                  )}{" "}
                                  {localizationStrings.timedAccessLock2}{" "}
                                  {this.convertEndTime(
                                    this.state.selectedLock.shareEndTime
                                  )}{" "}
                                  {localizationStrings.timedAccessLock3}
                                </p>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                          {/* <div
                            className={"displayBlock"}
                            style={{
                              display:
                                this.state.isSuperAdmin &&
                                this.state.radioIndividualLockChecked &&
                                !this.state.isSharedLock
                                  ? "block"
                                  : "none",
                              paddingBottom: this.state.noShareableLocks
                                ? "13px"
                                : "0",
                            }}
                          >
                            <br />
                            <br />
                            <br />
                            <FilterOption
                              isDisabledSwitch={isDisabledSwitch}
                              onSwitchChange={this.handleSwitchChange}
                              checkboxChecked5={this.state.checkboxChecked5}
                              onCheckboxChange4={this.onCheckboxChange4}
                              checkboxChecked6={this.state.checkboxChecked6}
                              onCheckboxChange5={this.onCheckboxChange5}
                            />
                          </div> */}
                        </div>
                      </div>
                      <div
                        className={"displayBlock"}
                        style={{
                          display:
                            this.state.isSuperAdmin &&
                            this.state.radioGrouplockChecked &&
                            !this.state.isSharedLock
                              ? "block"
                              : "none",
                        }}
                      >
                        <br />
                        <br />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            width: "100%",
                          }}
                        >
                          <div style={{ flex: 1, maxWidth: "70%" }}>
                            <Select
                              value={
                                this.state.selectedLockgroup
                                  ? {
                                      label: this.state.selectedLockgroup,
                                      value: this.state.selectedLockgroup,
                                    }
                                  : null
                              }
                              onChange={this.detectOnLockDropdownChangeEvent2}
                              options={this.renderDropdown2()}
                              placeholder={localizationStrings.selectLockGroup}
                              aria-label={localizationStrings.selectLockTitle}
                              formatOptionLabel={({ label }) => label}
                              isClearable={true}
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  outline: "none",
                                  boxShadow: state.isFocused
                                    ? "none"
                                    : provided.boxShadow,
                                  borderColor: state.isFocused
                                    ? "black"
                                    : provided.borderColor,
                                  width: "100%",
                                  backgroundColor: "white",
                                  color: "black",
                                  fontWeight: "bold",
                                  border: "4px solid #3c3e41",
                                  borderRadius: "12px",
                                  "&:hover": {
                                    borderColor: "black",
                                    cursor: "pointer",
                                  },
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  fontWeight: "bold",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: "black",
                                  fontWeight: "bold",
                                }),
                                indicatorsContainer: (provided) => ({
                                  ...provided,
                                  color: "black",
                                }),
                                dropdownIndicator: (provided, state) => ({
                                  ...provided,
                                  color: "black",
                                  "&:hover": {
                                    color: "black",
                                  },
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  backgroundColor: "black",
                                }),
                                clearIndicator: (provided) => ({
                                  ...provided,
                                  color: "black",
                                  "&:hover": {
                                    color: "black",
                                  },
                                }),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="thenLine">
                      <div className="horizontalLine"></div>
                      <p>then</p>
                      <div className="horizontalLine"></div>
                    </div> */}
                    <div className={"displayBlock"}>
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1.8em",
                            fontWeight: "bolder",
                            marginTop: "60px",
                            marginTop: this.state.radioIndividualLockChecked
                              ? this.state.noShareableLocks
                                ? "53px"
                                : "60px"
                              : "67px",
                            marginBottom: "25px",
                          }}
                        >
                          {localizationStrings.step2Message}
                        </h5>
                        <Radio
                          className="grantAccessRadioBtn"
                          style={{ fontSize: "1.3em", fontWeight: "bold" }}
                          name="radioGroup"
                          inline
                          checked={this.state.radioIndividualChecked} //main
                          onClick={this.handleRadioIndividual}
                          readOnly
                        >
                          &nbsp;
                          {localizationStrings.selectTypeTitle1}
                        </Radio>
                        <Radio
                          className="grantAccessRadioBtn"
                          style={{
                            fontSize: "1.3em",
                            fontWeight: "bold",
                            marginLeft: "30px",
                          }}
                          name="radioGroup"
                          inline
                          checked={this.state.radioGroupChecked}
                          onClick={this.handleRadioGroup}
                          readOnly
                        >
                          &nbsp;
                          {localizationStrings.selectTypeTitle2}
                        </Radio>
                      </div>
                    </div>
                    <div
                      className={"displayBlock"}
                      // style={{ display: "flex" }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          marginBottom: !this.state.isSuperAdmin
                            ? this.state.showAdminLists
                              ? "20px"
                              : "35px"
                            : this.state.radioGroupChecked
                            ? this.state.showAdminLists
                              ? "20px"
                              : "35px"
                            : "0px",
                          // width: "400px"
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1.8em",
                            fontWeight: "bolder",
                            marginTop: "60px",
                          }}
                        >
                          {!this.state.radioGroupChecked
                            ? localizationStrings.step3IndividualMessage
                            : localizationStrings.step3GroupMessage}
                        </h5>
                        {!this.state.radioGroupChecked ? (
                          /* <Multiselect
                            containerClassName={"grantAccessMultiSelect"}
                            data={
                              // this.state.showTable ?
                              this.state.selectedAdmins.length > 0
                                ? this.state.subtractRecipientArray
                                : this.state.userFriendListArray
                              // : this.state.userFriendListArray
                            }
                            value={this.state.selectedRecipients}
                            valueField="userEmail"
                            textField="userEmail"
                            onChange={this.handleFriendsArray}
                            placeholder={localizationStrings.selectRecipientTitle}
                          /> */
                          <RecipientsTable
                            visible={true}
                            recipientList={
                              this.state.selectedAdmins.length > 0
                                ? this.state.subtractRecipientArray
                                : this.state.userFriendListArray
                            }
                            dataCallBack={this.updateRecipientChanges}
                            selectedRecipients={this.state.selectedRecipients}
                            // style={{ textAlign: "center"}}
                          />
                        ) : (
                          <GroupsTable
                            visible={true}
                            groupList={this.state.groupListArray}
                            dataCallBack={this.updateGroupChanges}
                            selectedGroups={this.state.selectedGroups}
                          />
                        )}
                      </div>
                    </div>

                    {/* <br /> */}

                    {/* <div
                      className={"dropDownInput"}
                      style={{
                        width: "400px",
                        display: this.state.showAdminLists ? "block" : "none"
                      }}
                    >
                      <Multiselect
                        containerClassName={"grantAccessMultiSelect"}
                        data={this.conditionRenderingMultiData(
                          this.state.showAdminLists
                        )}
                        value={this.state.selectedAdmins}
                        valueField="adminEmail"
                        textField="adminEmail"
                        onChange={this.handleChangeMultiSharing}
                        placeholder={localizationStrings.requestAccessFrom}
                      />
                      <br />
                    </div> */}

                    <div
                      className={"displayBlock"}
                      style={{
                        display:
                          this.state.isSuperAdmin &&
                          this.state.radioIndividualChecked &&
                          !this.state.radioGrouplockChecked &&
                          !this.state.isSharedLock
                            ? "block"
                            : "none",
                      }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                        }}
                      >
                        <Checkbox
                          inline
                          checked={this.state.checkboxChecked}
                          onChange={this.handleCheck}
                          style={{
                            color: "#0e78db",
                            fontSize: "1.4em",
                            fontWeight: "bold",
                            marginTop: "0.1em",
                            marginLeft: "0.1em",
                            marginBottom: "60px",
                          }}
                        >
                          <span style={{ marginRight: "10px" }}></span>
                          {localizationStrings.checkboxText}
                        </Checkbox>
                      </div>
                    </div>

                    {/* Start of recurring */}
                    {/* <div className={"displayBlock"}>
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                          marginBottom: this.state.radioRecurringChecked
                            ? "40px"
                            : "60px",
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1.8em",
                            fontWeight: "bolder",
                            marginBottom: "25px",
                          }}
                        >
                          {localizationStrings.step4Message}
                        </h5>
                        <div style={{ display: "flex" }}>
                          <Radio
                            className="grantAccessRadioBtn"
                            style={{ fontSize: "1.3em", fontWeight: "bold" }}
                            name="sharingGroup"
                            inline
                            checked={this.state.radioNormalChecked}
                            onClick={this.handleRadioNormal}
                            readOnly
                          >
                            &nbsp;
                            {localizationStrings.step4NormalOption}
                          </Radio>
                          <Radio
                            className="grantAccessRadioBtn"
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginLeft: "30px",
                            }}
                            name="sharingGroup"
                            inline
                            checked={this.state.radioRecurringChecked}
                            onClick={this.handleRadioRecurring}
                            readOnly
                          >
                            &nbsp;
                            {localizationStrings.step4RecurringOption}
                          </Radio>
                        </div>
                        <p
                          className={"switchInfo switchOnOffine"}
                          style={{
                            display: this.state.radioRecurringChecked
                              ? "block"
                              : "none",
                            color: "red",
                            padding: "0px",
                          }}
                        >
                          {localizationStrings.recurringCurrentlyUnavailable}
                        </p>
                      </div>
                    </div> */}
                    {/* End of recurring */}

                    <div
                      className={"displayBlock"}
                      style={{
                        display: this.state.radioRecurringChecked
                          ? "block"
                          : "none",
                        marginBottom: "40px",
                        width: "100%",
                      }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          display: this.state.timechecked ? "block" : "none",
                          padding: "0% 15%",
                          width: "100%",
                          // width: "400px"
                          marginBottom: this.state.radioRecurringChecked
                            ? "30px"
                            : "60px",
                        }}
                      >
                        {/* access period start */}
                        <h5
                          style={{
                            fontSize: "1.6em",
                            fontWeight: "bolder",
                            marginBottom: "16px",
                          }}
                        >
                          {localizationStrings.step4AccessTitle}
                        </h5>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "1.3em",
                                fontWeight: "bold",
                                marginRight: "10px",
                                width:
                                  localizationStrings.getLanguage() === "ja"
                                    ? "100px"
                                    : "50px",
                              }}
                            >
                              {localizationStrings.step4Start}
                            </div>
                            <div style={{ width: "200px" }}>
                              <DatePicker
                                placeholderText={this.state.calendarStartText}
                                selected={this.state.startDate}
                                onChange={this.handleStartDateChange}
                                showTimeSelect
                                dateFormat="dd/MM/yyyy, HH:mm a"
                              />
                            </div>
                          </div>
                          <div style={{ width: "20px" }} />
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "1.3em",
                                fontWeight: "bold",
                                marginRight: "10px",
                                width:
                                  localizationStrings.getLanguage() === "ja"
                                    ? "100px"
                                    : "50px",
                              }}
                            >
                              {localizationStrings.step4End}
                            </div>
                            <div style={{ width: "200px" }}>
                              <DatePicker
                                placeholderText={this.state.calendarEndText}
                                selected={this.state.endDate}
                                onChange={this.handleEndDateChange}
                                showTimeSelect
                                dateFormat="dd/MM/yyyy, HH:mm a"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Select Day(s) : */}
                    <div
                      className={"displayBlock"}
                      style={{
                        display: this.state.radioRecurringChecked
                          ? "block"
                          : "none",
                        marginBottom: "30px",
                        width: "100%",
                      }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                          width: "100%",
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1.6em",
                            fontWeight: "bolder",
                            marginBottom: "16px",
                          }}
                        >
                          {localizationStrings.step4RecurringTitle}
                        </h5>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            flexWrap: "wrap",
                          }}
                        >
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckSun}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckSun"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDaySun}
                          </Checkbox>
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckMon}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckMon"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDayMon}
                          </Checkbox>
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckTue}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckTue"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDayTue}
                          </Checkbox>
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckWed}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckWed"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDayWed}
                          </Checkbox>
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckThu}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckThu"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDayThu}
                          </Checkbox>
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckFri}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckFri"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDayFri}
                          </Checkbox>
                          <Checkbox
                            inline
                            checked={this.state.recurringCheckSat}
                            // checked={this.state.checkboxChecked}
                            onChange={this.handleRecurringCheck}
                            name={"recurringCheckSat"}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginTop: "0.1em",
                              marginLeft: "0.1em",
                              marginRight: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}></span>
                            {localizationStrings.recurringDaySat}
                          </Checkbox>
                        </div>
                        <div style={{ display: "flex", width: "100%" }}>
                          {" "}
                          {/* for selected days: */}
                          {/* <div 
                              style={{
                                fontSize: "1.3em",
                                fontWeight: "bold",
                                marginRight: "10px",
                                width: localizationStrings.getLanguage() === "ja" ? "100px" : "100px"
                              }}
                            >
                              {"Selected: "}
                            </div> */}
                          <div
                            style={{
                              color: "#0e78db",
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginRight: "10px",
                              width: "100%",
                              wordWrap: "break-word",
                            }}
                          >
                            <p
                              className={"switchInfo switchOnOffine"}
                              style={{
                                color: "#0e78db",
                              }}
                            >
                              {this.state.recurringCheckSun ||
                              this.state.recurringCheckMon ||
                              this.state.recurringCheckTue ||
                              this.state.recurringCheckWed |
                                this.state.recurringCheckThu |
                                this.state.recurringCheckFri |
                                this.state.recurringCheckSat
                                ? localizationStrings.everyLabel +
                                  (
                                    (this.state.recurringCheckSun
                                      ? localizationStrings.recurringDaySun +
                                        ", "
                                      : "") +
                                    (this.state.recurringCheckMon
                                      ? localizationStrings.recurringDayMon +
                                        ", "
                                      : "") +
                                    (this.state.recurringCheckTue
                                      ? localizationStrings.recurringDayTue +
                                        ", "
                                      : "") +
                                    (this.state.recurringCheckWed
                                      ? localizationStrings.recurringDayWed +
                                        ", "
                                      : "") +
                                    (this.state.recurringCheckThu
                                      ? localizationStrings.recurringDayThu +
                                        ", "
                                      : "") +
                                    (this.state.recurringCheckFri
                                      ? localizationStrings.recurringDayFri +
                                        ", "
                                      : "") +
                                    (this.state.recurringCheckSat
                                      ? localizationStrings.recurringDaySat +
                                        ","
                                      : "")
                                  ).replace(/,\s*$/, "")
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Select Daily Access : */}
                    <div
                      className={"displayBlock"}
                      style={{
                        display: this.state.radioRecurringChecked
                          ? "block"
                          : "none",
                        marginBottom: "40px",
                        width: "100%",
                      }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1.6em",
                            fontWeight: "bolder",
                            marginBottom: "16px",
                          }}
                        >
                          {localizationStrings.step4SelectDaily}
                        </h5>
                        <div style={{ display: "flex" }}>
                          <Radio
                            className="grantAccessRadioBtn"
                            style={{ fontSize: "1.3em", fontWeight: "bold" }}
                            name="dailyAccess"
                            inline
                            checked={this.state.recurringFullDay}
                            onClick={this.handleRadioFullDay}
                            readOnly
                          >
                            &nbsp;
                            {localizationStrings.step4FullDay}
                          </Radio>
                          <Radio
                            className="grantAccessRadioBtn"
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              marginLeft: "30px",
                            }}
                            name="dailyAccess"
                            inline
                            checked={this.state.recurringTimed}
                            onClick={this.handleRadioTimeAccess}
                            readOnly
                          >
                            &nbsp;
                            {localizationStrings.step4Timed}
                          </Radio>
                        </div>
                      </div>
                    </div>

                    <div
                      className={"displayBlock"}
                      style={{
                        display: this.state.radioRecurringChecked
                          ? this.state.recurringTimed
                            ? "block"
                            : "none"
                          : "none",
                        marginBottom: "40px",
                        width: "100%",
                      }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          display: "block",
                          padding: "0% 15%",
                          width: "100%",
                          // width: "400px"
                          marginBottom: this.state.radioRecurringChecked
                            ? "30px"
                            : "60px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            {localizationStrings.getLanguage() === "ja" ? (
                              ""
                            ) : (
                              <div
                                style={{
                                  fontSize: "1.3em",
                                  fontWeight: "bold",
                                  marginRight: "10px",
                                  width: "50px",
                                }}
                              >
                                {localizationStrings.step4FromOption}
                              </div>
                            )}
                            <div style={{ width: "200px" }}>
                              <DatePicker
                                placeholderText={this.state.recurringStartText}
                                selected={this.state.startTime}
                                onChange={this.handleStartTimeChange}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={30}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                              />
                            </div>
                            {localizationStrings.getLanguage() === "en" ||
                            "es" ? (
                              ""
                            ) : (
                              <div
                                style={{
                                  fontSize: "1.3em",
                                  fontWeight: "bold",
                                  marginLeft: "10px",
                                  width: "50px",
                                }}
                              >
                                {localizationStrings.step4FromOption}
                              </div>
                            )}
                          </div>
                          <div style={{ width: "20px" }} />
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            {localizationStrings.getLanguage() === "ja" ? (
                              ""
                            ) : (
                              <div
                                style={{
                                  fontSize: "1.3em",
                                  fontWeight: "bold",
                                  marginRight: "10px",
                                  width: "50px",
                                }}
                              >
                                {localizationStrings.step4ToOption}
                              </div>
                            )}
                            <div style={{ width: "200px" }}>
                              <DatePicker
                                placeholderText={this.state.recurringEndText}
                                selected={this.state.endTime}
                                onChange={this.handleEndTimeChange}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={30}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                              />
                            </div>
                            {localizationStrings.getLanguage() === "en" ||
                            "es" ? (
                              ""
                            ) : (
                              <div
                                style={{
                                  fontSize: "1.3em",
                                  fontWeight: "bold",
                                  marginLeft: "10px",
                                  width: "50px",
                                }}
                              >
                                {localizationStrings.step4ToOption}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={"displayBlock"}
                      style={{
                        display: this.state.radioRecurringChecked
                          ? "block"
                          : "none",
                        marginBottom: "40px",
                        width: "100%",
                      }}
                    >
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                          width: "100%",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <label
                            htmlFor="normal-switch"
                            style={{ width: "250px" }}
                          >
                            <h5
                              style={{
                                fontSize: "1.6em",
                                fontWeight: "bolder",
                                height: "30px",
                                margin: "0px",
                              }}
                            >
                              {localizationStrings.sharingModeTitle}
                            </h5>
                          </label>

                          <Switch
                            onChange={this.handleChange}
                            checked={this.state.isRetractMode}
                            disabled={
                              this.state.disabledState ||
                              this.state.disabledStateMultiShare ||
                              this.state.disabledStateShareLock
                            }
                            id="normal-switch"
                          />
                        </div>
                        {this.state.isRetractMode ? (
                          <p
                            className={"switchInfo switchOnOffine"}
                            style={{ color: "red", padding: "0px" }}
                          >
                            {localizationStrings.onlineWarning}
                          </p>
                        ) : (
                          <p
                            className={"switchInfo switchOnOffine"}
                            style={{ color: "grey", padding: "0px" }}
                          >
                            {localizationStrings.offlineWarning}
                          </p>
                        )}
                      </div>
                    </div>

                    {this.state.showAdminLists ? (
                      <div
                        className={"dropDownInput"}
                        style={{
                          padding: "0% 15%",
                          // width: "400px"
                          // display: this.state.showAdminLists ? "block" : "none"
                        }}
                      >
                        <p style={{ color: "red", fontSize: "1.3em" }}>
                          {localizationStrings.step5SubMessage}
                        </p>
                        <h5
                          style={{
                            fontSize: "1.8em",
                            fontWeight: "bolder",
                            // marginTop:
                            //   this.state.isSuperAdmin &&
                            //   this.state.radioIndividualChecked &&
                            //   !this.state.isSharedLock
                            //     ? "50px"
                            //     : "0px"
                          }}
                        >
                          {localizationStrings.step5Message}
                        </h5>
                        {/* <Multiselect
                        style={{ marginBottom: "50px" }}
                        containerClassName={"grantAccessMultiSelect"}
                        data={this.conditionRenderingMultiData(
                          this.state.showAdminLists
                        )}
                        value={this.state.selectedAdmins}
                        valueField="adminEmail"
                        textField="adminEmail"
                        onChange={this.handleChangeMultiSharing}
                        placeholder={localizationStrings.requestAccessFrom}
                      /> */}
                        <AdminsTable
                          visible={true}
                          adminList={this.conditionRenderingMultiData(
                            this.state.showAdminLists
                          )}
                          dataCallBack={this.updateAdminChanges}
                          selectedAdmins={this.state.selectedAdmins}
                          // typeIsIndividual={this.state.radioIndividualChecked}
                          // typeIsGroup={this.state.radioGroupChecked}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    {/* </div> */}

                    {/* </div> */}
                    {/* {this.state.showAdminLists ? (
                      ""
                    ) : (
                      <div>
                        <br />
                        <br />
                      </div>
                    )} */}

                    {!this.state.radioGroupChecked ? (
                      <RecipientsTable
                        visible={this.state.showTable}
                        selectedRecipients={this.state.selectedRecipients}
                        // style={{ textAlign: "center"}}
                      />
                    ) : (
                      <GroupsTable
                        visible={this.state.showTable}
                        selectedGroups={this.state.selectedGroups}
                      />
                    )}
                    {this.state.showTable ? <br /> : ""}

                    <br />
                    {/* <br /> */}
                    <div
                      className="grantSwitchInput"
                      style={{
                        display: this.state.radioRecurringChecked ? "none" : "",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <div>
                          <label
                            htmlFor="normal-switch"
                            style={{ width: "250px" }}
                          >
                            <strong>
                              {localizationStrings.step4AccessTitle}
                              <a data-tip data-for="usernameTip">
                                <span
                                  style={{
                                    color: "#3C3E41",
                                    fontSize: "15px",
                                    marginLeft: "10px",
                                  }}
                                  className="glyphicon glyphicon-info-sign"
                                  aria-hidden="true"
                                ></span>
                              </a>
                              <ReactTooltip id="usernameTip" effect="solid">
                                <span>{localizationStrings.usernameTip}</span>
                              </ReactTooltip>
                            </strong>
                          </label>
                          <br />
                          <Switch
                            onChange={this.handleTimedAccess}
                            checked={this.state.timechecked}
                            id="normal-switch"
                          />
                        </div>

                        <div style={{ display: "flex", width: "100%" }}>
                          <span style={{ width: "100%" }}>
                            {/* If TimedAccess switch is true (Ticked) */}
                            {this.state.timechecked ? (
                              <Row>
                                <DatePicker
                                  placeholderText={this.state.calendarStartText}
                                  selected={this.state.startDate}
                                  onChange={this.handleStartDateChange}
                                  showTimeSelect
                                  dateFormat="dd/MM/yyyy, HH:mm a"
                                  style={{ marginRight: "30px" }}
                                />

                                <br />

                                <DatePicker
                                  placeholderText={this.state.calendarEndText}
                                  selected={this.state.endDate}
                                  onChange={this.handleEndDateChange}
                                  showTimeSelect
                                  dateFormat="dd/MM/yyyy, HH:mm a"
                                  style={{ marginRight: "30px" }}
                                />
                              </Row>
                            ) : (
                              //if TimedAccess switch is false
                              <p
                                className={"switchInfo"}
                                style={{ color: "grey", padding: "0px 20px" }}
                              >
                                {localizationStrings.unrestrictedTitle}
                              </p>
                            )}
                          </span>
                        </div>

                        <br />
                        {!this.state.radioGrouplockChecked && (
                          <>
                            <div>
                              <label
                                htmlFor="normal-switch"
                                style={{ width: "250px" }}
                              >
                                <strong>
                                  {localizationStrings.mutliApprove}
                                  <a data-tip data-for="usernameTip2">
                                    <span
                                      style={{
                                        color: "#3C3E41",
                                        fontSize: "15px",
                                        marginLeft: "10px",
                                      }}
                                      className="glyphicon glyphicon-info-sign"
                                      aria-hidden="true"
                                    ></span>
                                  </a>
                                  <ReactTooltip
                                    id="usernameTip2"
                                    effect="solid"
                                  >
                                    <span>
                                      {localizationStrings.usernameTip2}
                                    </span>
                                  </ReactTooltip>
                                </strong>
                              </label>
                              <br />

                              <Switch
                                onChange={this.handleChangeMultiSharing}
                                checked={this.state.showAdminLists}
                                id="normal-switch"
                                disabled={this.state.checkboxChecked}
                              />
                            </div>

                            <div>
                              <span>
                                {this.state.showAdminLists ? (
                                  <p
                                    className={"switchInfo switchOnOffine"}
                                    style={{ color: "red" }}
                                  >
                                    {localizationStrings.availableOnlineOnly}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </>
                        )}
                      </div>

                      <div
                        className="middleLineDrawing"
                        style={{
                          height: this.state.radioGrouplockChecked
                            ? "100px"
                            : "200px",
                        }}
                      ></div>

                      <div
                        style={{
                          // marginLeft: "60px",
                          width: "50%",
                        }}
                      >
                        <div
                        // style={{ marginLeft: "60px" }}
                        >
                          <label
                            htmlFor="normal-switch"
                            style={{ width: "250px" }}
                          >
                            <strong>
                              {localizationStrings.sharingModeTitle}
                            </strong>
                          </label>
                          <br />

                          <Switch
                            onChange={this.handleChange}
                            checked={this.state.isRetractMode}
                            disabled={
                              this.state.disabledState ||
                              this.state.disabledStateMultiShare ||
                              this.state.disabledStateShareLock
                            }
                            id="normal-switch"
                          />
                        </div>
                        <div>
                          <span>
                            {this.state.isRetractMode ? (
                              <p
                                className={"switchInfo switchOnOffine"}
                                style={{ color: "red", padding: "0px 20px" }}
                              >
                                {localizationStrings.onlineWarning}
                              </p>
                            ) : (
                              <p
                                className={"switchInfo switchOnOffine"}
                                style={{ color: "grey", padding: "0px 20px" }}
                              >
                                {localizationStrings.offlineWarning}
                              </p>
                            )}
                          </span>
                        </div>

                        <br />
                        {!this.state.radioGrouplockChecked && (
                          <>
                            <div>
                              <label
                                htmlFor="normal-switch"
                                style={{ width: "250px" }}
                              >
                                <strong>
                                  {localizationStrings.oneTimeAccess}
                                  <a data-tip data-for="usernameTip3">
                                    <span
                                      style={{
                                        color: "#3C3E41",
                                        fontSize: "15px",
                                        marginLeft: "10px",
                                      }}
                                      className="glyphicon glyphicon-info-sign"
                                      aria-hidden="true"
                                    ></span>
                                  </a>
                                  <ReactTooltip
                                    id="usernameTip3"
                                    effect="solid"
                                  >
                                    <span>
                                      {localizationStrings.usernameTip3}
                                    </span>
                                  </ReactTooltip>
                                </strong>
                              </label>
                              <br />

                              <Switch
                                onChange={this.handleChangeOTA}
                                checked={this.state.OTAMode}
                                id="normal-switch"
                                disabled={
                                  this.state.radioGroupChecked ||
                                  this.state.checkboxChecked
                                }
                              />
                            </div>
                            <div>
                              <span>
                                {this.state.OTAMode ? (
                                  <p
                                    className={"switchInfo switchOnOffine"}
                                    style={{ color: "red" }}
                                  >
                                    {localizationStrings.availableOnlineOnly}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <br />
                    <br />

                    <Row>
                      <Button
                        className={"clearSendBtn"}
                        style={{ width: "100%", marginTop: "20px" }}
                        type="reset"
                        onClick={this.clearForm}
                        disabled={this.state.processing}
                      >
                        {localizationStrings.clearButton}
                      </Button>
                    </Row>

                    <Row>
                      <Button
                        className="loginsignupbutton"
                        style={{ width: "100%", marginTop: "20px" }}
                        onClick={this.onSendRemoteAccess}
                        disabled={
                          this.state.invalidMemberLimit ||
                          this.state.invalidLockLimit
                            ? true
                            : this.state.processing
                        }
                      >
                        <strong>
                          {this.state.processing
                            ? localizationStrings.processing
                            : localizationStrings.sendButton}
                        </strong>
                      </Button>
                    </Row>
                  </FormGroup>
                </form>
              </div>
            )}
          </TabPanel>

          <TabPanel>
            <ShareHistory />
          </TabPanel>

          {/* <TabPanel>
            <LockScheduling />
          </TabPanel> */}

          {/* <TabPanel>
            <GroupSharing />
          </TabPanel> */}
        </Tabs>
        <div className="empty-space"></div>
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.popupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.popupImage}</Modal.Body>
        </Modal>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(GrantAccess);
